
<div class="pricingWrapSection">
    <div id="particles-js"></div>
    <div class="pricing_top_banner">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="pricingBannerContent">
                        <h1>料金プラン</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="choosePlan">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="pricingContainer">
                        <!-- Basic-->
                        <div class="pricingCardBox">
                            <div class="pricingCardHeader">
                                <div class="cardTop">
                                    <h2>ベーシック</h2>
                                    <div class="amount">
                                        <div class="amt_div">
                                            <b>{{decodedData[0].currency}}</b><h3>0</h3><span>/1か月</span>
                                        </div>
                                    </div>
                                    <div class="infoContainer">
                                        <p>無料</p>
                                    </div>
                                </div>
                                <div class="cardButton">
                                    <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">さっそく始める</a>
                                </div>
                            </div>
                            <div class="pricingCardBody">
                                <h4 class="mdTitle d-md-block d-none"></h4>
                                <div class="cardSection">
                                    <div class="innerCard">
                                        <h6>文法チェック</h6>
                                        <ul class="checkLister">
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span>英文法 <em>(1か月20,000単語まで)</em></span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span>パラフレーズ <em>(1か月5000単語まで)</em></span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span>ファイル自動校正 <em>(最大1か月4回まで )</em> <div class="avaliableOnCredits">ポイント (Credit )利用</div></span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="innerCard">
                                        <h6>ポイント (Credit )</h6>
                                        <ul class="checkLister">
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span>4ポイント (Credit )/月</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="innerCard plagiarismCheck">
                                        <h6>盗用・剽窃チェック</h6>
                                        <ul class="checkLister">
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span>盗用・剽窃スコア 算出 <em>(月1回まで無料) by</em> <img src="../../../assets/images/itendicate_logo.svg" alt="itendicate_logo" /></span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span>iThenticate® 盗用・剽窃レポート <br/><em>by</em> <img src="../../../assets/images/itendicate_logo.svg" alt="itendicate_logo" /> <br/><div class="avaliableOnCredits">ポイント (Credit )利用</div></span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span>Trinka 盗用・剽窃レポート <br/><em> by </em> <img src="../../../assets/images/itendicate_logo.svg" alt="itendicate_logo" /> <br/><div class="avaliableOnCredits">ポイント (Credit )利用</div></span>
                                            </li>
                                            <!-- <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span>AIによる生成コンテンツ検出 <br/><div class="avaliableOnCredits">ポイント (Credit )利用</div></span>
                                            </li> -->
                                        </ul>
                                    </div>
                                    <div class="innerCard extensionAddin">
                                        <h6>拡張機能とアドイン</h6>
                                        <ul class="checkLister">
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span><p>ブラウザ拡張機能</p> <br/> - Chrome<br/>- Firefox<br/>- Edge </span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="innerCard aiProducts">
                                        <h6>他のAI製品との接続</h6>
                                        <ul class="checkLister">
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span>
                                                    <h3 class="flex-column"><p class="bold">Enago Reports</p><div class="avaliableOnCredits">ポイント (Credit )利用</div></h3>
                                                    - 言語の品質<br/>
                                                    - 多様性への配慮<br/>
                                                    - 専門性<br/>
                                                    - 参考文献の品質<br/>
                                                    - ジャーナルファインダー                                                    
                                                </span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span><p class="bold">Enago Read</p><br/>
                                                    - コパイロット機能<br/>
                                                    - セクション別サマリー<br/>
                                                    - 要点のリストアップ<br/>
                                                    - 関連論文                                                    
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="cardButton ftButton">
                                    <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">さっそく始める</a>
                                </div>
                            </div>
                        </div>
                        <!-- Premium -->
                        <div class="pricingCardBox premiumPlan">
                            <div class="pricingCardHeader premiumCardHeader">
                                <div class="cardTop">
                                    <h2>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M22.3741 8.70322L18.8221 3.34066C18.6809 3.12817 18.4423 3 18.1871 3H5.81368C5.55826 3 5.31983 3.12817 5.17863 3.34066L1.62667 8.70322C1.43714 8.98817 1.46244 9.36422 1.68821 9.62054L11.4273 20.7403C11.5712 20.9055 11.78 21 11.9999 21C12.2198 21 12.4286 20.9055 12.5732 20.7395L22.3123 9.61979C22.5373 9.3642 22.5626 8.98816 22.3741 8.70322ZM7.69844 9.88101L10.0589 16.8716L3.93597 9.88101H7.69844ZM13.7561 4.51844L14.7768 8.36335H9.22124L10.2419 4.51844H13.7561ZM14.6939 9.88101L11.9995 17.8627L9.30518 9.88101H14.6939ZM16.3007 9.88101H20.0634L13.9405 16.8716L16.3007 9.88101ZM20.3239 8.36253H16.3525L15.3318 4.51763H17.7775L20.3239 8.36253ZM6.22237 4.5184H8.6681L7.64741 8.3633H3.67506L6.22237 4.5184Z" fill="#7A28A0"/>
                                        </svg>
                                        プレミアム
                                    </h2>
                                    <div class="amount">
                                        <div id="yearly" class="amt_div" *ngIf="isYearlyChecked; else monthlyContent">
                                            <b>{{decodedData[0].currency}}</b>
                                            <h3>{{decodedData[2].final_amount / 12 | number:'1.2-2'}}</h3>
                                            <span>/1か月</span>
                                            <!-- <b>$</b><h3>67</h3><span>per month</span> -->
                                        </div>
                                    </div>
                                    <ng-template #monthlyContent>
                                        <div id="monthly" class="amt_div">
                                            <b>{{decodedData[0].currency}}</b>
                                            <h3>{{decodedData[2].amount| number:'1.0-0'}}</h3>
                                            <span>/1か月</span>
                                            <!-- <b>$</b><h3>20</h3><span>per month</span> -->
                                        </div>
                                    </ng-template>
                                    <div class="infoContainer">
                                        <p *ngIf="isYearlyChecked" class="minHeight">年払い年額{{decodedData[0].currency}} {{decodedData[2].final_amount| number:'1.0-0'}}</p>
                                        <p *ngIf="!isYearlyChecked" class="minHeight">請求済み {{decodedData[0].currency}} {{decodedData[2].amount| number:'1.0-0'}} 毎月</p>
                                        <div class="pricingToggleButton">
                                            <p>月払い</p>
                                            <label class="switch" style="margin:0 8px;">
                                                <input type="checkbox" checked [(ngModel)]="isYearlyChecked">
                                                <span class="slider round"></span>
                                            </label>
                                            <p>年払い <i *ngIf="isYearlyChecked">67%お得</i> </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="cardButton premiumButton">
                                    <a *ngIf="isYearlyChecked" href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">アップグレードする</a>
                                    <a *ngIf="!isYearlyChecked"href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">アップグレードする</a>
                                </div>
                            </div>
                            <div class="pricingCardBody">
                                <h4 class="mdTitle">ベーシックの<br/>全機能に加えて：</h4>
                                <div class="cardSection">
                                    <div class="innerCard">
                                        <h6>文法チェック</h6>
                                        <ul class="checkLister">
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span>英文法 *</span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span>パラフレーズ *</span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span>ファイル自動校正 <em>(最大10ファイルまで )</em> <div class="avaliableOnCredits">ポイント (Credit )利用</div></span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="innerCard">
                                        <h6>ポイント (Credit)</h6>
                                        <ul class="checkLister">
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span><div class="unlimited no-padding">10ポイント (Credit )</div>/月</span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span>追加クレジット購入、<div class="unlimited no-padding">最大40%割引</div></span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="innerCard plagiarismCheck">
                                        <h6>盗用・剽窃チェック</h6>
                                        <ul class="checkLister">
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span>盗用・剽窃スコア <em class="stripe-yellow">(月2回まで無料)</em> by <img src="../../../assets/images/itendicate_logo.svg" alt="itendicate_logo" /></span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="innerCard extensionAddin">
                                        <h6>拡張機能とアドイン</h6>
                                        <ul class="checkLister">
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span><h3 class="fontNormal nowrap"><p>ブラウザ拡張機能</p> <div class="unlimited">(無制限)</div></h3> - Chrome<br/>- Firefox<br/>- Edge </span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span><h3 class="fontNormal nowrap"><p>MS Wordアドイン</p> <div class="unlimited">(無制限)</div></h3>- Windows<br/>- Mac<br/>- Office 365 </span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="innerCard aiProducts"></div>
                                </div>
                                <div class="cardButton premiumButton ftButton">
                                    <a *ngIf="isYearlyChecked" href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">アップグレードする</a>
                                    <a *ngIf="!isYearlyChecked"href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">アップグレードする</a>
                                </div>
                            </div>
                        </div>
                        <!-- Premium Plus-->
                        <div class="pricingCardBox premiumPlus">
                            <div class="pricingCardHeader premiumPlusCardHeader">
                                <div class="cardTop">
                                    <h2>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M21.8861 12.0695L18.6724 7.3028C18.5446 7.11393 18.3287 7 18.0978 7H6.90285C6.67176 7 6.45604 7.11393 6.32828 7.3028L3.1146 12.0695C2.94313 12.3228 2.96601 12.6571 3.17028 12.8849L11.9819 22.7691C12.112 22.916 12.3009 23 12.4999 23C12.6989 23 12.8878 22.916 13.0186 22.7685L21.8302 12.8843C22.0338 12.6571 22.0567 12.3228 21.8861 12.0695ZM8.60811 13.1165L10.7437 19.3303L5.20397 13.1165H8.60811ZM14.0888 8.34973L15.0123 11.7674H9.98588L10.9094 8.34973H14.0888ZM14.9373 13.1165L12.4996 20.2113L10.0618 13.1165H14.9373ZM16.3912 13.1165H19.7954L14.2557 19.3303L16.3912 13.1165ZM20.0311 11.7667H16.4379L15.5145 8.349H17.7273L20.0311 11.7667ZM7.27262 8.34969H9.48542L8.56194 11.7674H4.96791L7.27262 8.34969Z" fill="#FDE68A"/>
                                            <path d="M6 1L6.81027 3.18973L9 4L6.81027 4.81027L6 7L5.18973 4.81027L3 4L5.18973 3.18973L6 1Z" fill="#FDE68A"/>
                                            <path d="M3 6L3.54018 7.45982L5 8L3.54018 8.54018L3 10L2.45982 8.54018L1 8L2.45982 7.45982L3 6Z" fill="#FDE68A"/>
                                        </svg>
                                        プレミアムプラス
                                    </h2>
                                    <div class="amount">
                                        <div class="amt_div">
                                            <b>{{decodedData[0].currency}}</b>
                                            <h3 class="text-white">{{decodedData[3].amount | number:'1.2-2'}}</h3>
                                            <span>/1か月</span>
                                            <!-- <b>$</b><h3>8.33</h3><span>per month</span> -->
                                        </div>
                                    </div>
                                    <div class="infoContainer">
                                        <p>年払い年額{{decodedData[0].currency}}{{decodedData[3].final_amount | number:'1.0-0'}}</p>
                                        <span>盗用・剽窃チェック利用の度に最大{{decodedData[0].currency}}{{decodedData[0].currency=='$'?'36 ':'2880 '}}お得に</span>
                                    </div>
                                </div>
                                <div class="cardButton premiumPlusButton">
                                    <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">アップグレードする</a>
                                </div>
                            </div>
                            <div class="pricingCardBody">
                                <h4 class="mdTitle">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M18.6451 7.25268L15.6851 2.78388C15.5674 2.60681 15.3686 2.5 15.1559 2.5H4.84473C4.63189 2.5 4.4332 2.60681 4.31552 2.78388L1.35556 7.25268C1.19762 7.49014 1.2187 7.80351 1.40684 8.01712L9.52278 17.2836C9.64265 17.4213 9.81664 17.5 9.99992 17.5C10.1832 17.5 10.3572 17.4213 10.4777 17.2829L18.5936 8.01649C18.7811 7.8035 18.8022 7.49014 18.6451 7.25268ZM6.41536 8.23417L8.38239 14.0597L3.27998 8.23417H6.41536ZM11.4634 3.76537L12.314 6.96946H7.68436L8.53494 3.76537H11.4634ZM12.2449 8.23417L9.99962 14.8856L7.75432 8.23417H12.2449ZM13.584 8.23417H16.7195L11.617 14.0597L13.584 8.23417ZM16.9366 6.96878H13.627L12.7765 3.76469H14.8146L16.9366 6.96878ZM5.18531 3.76533H7.22341L6.37284 6.96942H3.06255L5.18531 3.76533Z" fill="white"/>
                                    </svg> プレミアムの<br/>全機能に加えて：
                                </h4>
                                <div class="cardSection">
                                    <div class="innerCard plagiarismCheck">
                                        <h6>盗用・剽窃チェック</h6>
                                        <ul class="checkLister">
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#DDE2E9"/>
                                                </svg>
                                                <span>
                                                    回数無制限*Trinka 盗用・剽窃レポート <br/><em>by</em> <img src="../../../assets/images/ithenticate_logo_white.svg" alt="ithenticate_logo" />
                                                    <div class="note"><i>*</i><p>初日から120ページ分利用可能 <small>(1ページ=250単語)</small></p> </div>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="cardButton premiumPlusButton ftButton">
                                    <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">アップグレードする</a>
                                </div>
                            </div>
                        </div>
                        <!-- Enterprise-->
                        <div class="pricingCardBox enterpriseBox">
                            <div class="pricingCardHeader enterpriseHeader">
                                <div class="cardTop">
                                    <h2>
                                        Trinka Enterprise
                                    </h2>
                                    <div class="infoContainer">
                                        <h6>高いセキュリティと柔軟性を<br>兼ね備えた法人向けプラン</h6>
                                    </div>
                                </div>
                                <div class="cardButton enterpriseButton">
                                    <a href="javascript:void(0)" data-toggle="modal" data-target="#EnterPriseContactPopup">お問い合わせ</a>
                                </div>
                            </div>
                            <div class="pricingCardBody">
                                <h4 class="mdTitle">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M18.8981 9.43584L16.0227 5.26495C15.9083 5.09969 15.7152 5 15.5086 5H5.49202C5.28526 5 5.09225 5.09969 4.97794 5.26495L2.10254 9.43584C1.94911 9.65746 1.96959 9.94995 2.15236 10.1493L10.0364 18.798C10.1529 18.9265 10.3219 19 10.4999 19C10.678 19 10.847 18.9265 10.964 18.7974L18.8481 10.1487C19.0302 9.94994 19.0507 9.65746 18.8981 9.43584ZM7.01778 10.3519L8.92861 15.789L3.97198 10.3519H7.01778ZM11.9216 6.18101L12.7479 9.1715H8.25052L9.0768 6.18101H11.9216ZM12.6808 10.3519L10.4996 16.5599L8.31848 10.3519H12.6808ZM13.9816 10.3519H17.0275L12.0708 15.789L13.9816 10.3519ZM17.2384 9.17086H14.0234L13.1971 6.18038H15.177L17.2384 9.17086ZM5.82287 6.18097H7.80275L6.97647 9.17146H3.76076L5.82287 6.18097Z" fill="#111A27"/>
                                        <path d="M5.5 0L6.17523 1.82477L8 2.5L6.17523 3.17523L5.5 5L4.82477 3.17523L3 2.5L4.82477 1.82477L5.5 0Z" fill="#111A27"/>
                                        <path d="M1.66667 4L2.11682 5.21652L3.33333 5.66667L2.11682 6.11682L1.66667 7.33333L1.21652 6.11682L0 5.66667L1.21652 5.21652L1.66667 4Z" fill="#111A27"/>
                                    </svg>プレミアムプラスの<br/>全機能に加えて：
                                </h4>
                                <div class="cardSection">
                                    <div class="innerCard enterpriseCard">
                                        <ul class="checkLister">
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span class="custom-tooltip">高機密データ管理
                                                    <div class="custom-tooltip-content">
                                                        AIがお客様のデータを学習したり、データを保存したりすることはありません。お客様のデータの管理権限に介入することもありません。
                                                    </div>
                                                </span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span class="custom-tooltip">複数の統合オプション
                                                    <div class="custom-tooltip-content">
                                                        JavaScript、API、オンプレミスの3つのオプションでTrinkaを統合できます。
                                                    </div>
                                                </span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span class="custom-tooltip">お客様に合わせた料金設定
                                                    <div class="custom-tooltip-content">
                                                        ユーザー、単語、APIコールの数に基づく料金設定。
                                                    </div>
                                                </span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span class="custom-tooltip">一括ライセンス 
                                                    <div class="custom-tooltip-content">
                                                        一括ライセンスを購入すれば、Trinka Cloudから、Wordアドイン、ブラウザプラグインまで、Trinkaへのアクセス権をチーム全体でお使いいただけます。
                                                    </div>
                                                </span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span class="custom-tooltip">IPホワイトリスト
                                                    <div class="custom-tooltip-content">
                                                        指定したIPアドレスからのみTrinkaへのアクセスが可能。
                                                    </div>
                                                </span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span class="custom-tooltip">ホワイトラベルソリューション
                                                    <div class="custom-tooltip-content">
                                                        エンドユーザーが、御社企業ブランドを冠したシステムでTrinkaにアクセスできます。
                                                    </div>
                                                </span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span class="custom-tooltip">包括的な分析
                                                    <div class="custom-tooltip-content">
                                                        Trinkaの使用状況やシステムパフォーマンスに関する情報を入手し、十分な情報に基づいた意思決定を行うことができます。
                                                    </div>
                                                </span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span class="custom-tooltip">カスタマイズ 
                                                    <div class="custom-tooltip-content">
                                                        スタイルガイド、ルールなど、オンデマンドで条件を追加できます。
                                                    </div>
                                                </span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span class="custom-tooltip">シンプルなユーザー管理
                                                    <div class="custom-tooltip-content">
                                                        ユーザーのアクセス管理、ライセンスの交換、メンバーの追加が可能です。
                                                    </div>
                                                </span>
                                            </li>
                                            <li>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.8041 4.20014C14.0644 4.46049 14.0644 4.8826 13.8041 5.14295L7.13742 11.8096C6.87707 12.07 6.45496 12.07 6.19461 11.8096L2.86128 8.47629C2.60093 8.21594 2.60093 7.79383 2.86128 7.53348C3.12163 7.27313 3.54374 7.27313 3.80409 7.53348L6.66602 10.3954L12.8613 4.20014C13.1216 3.9398 13.5437 3.9398 13.8041 4.20014Z" fill="#414E62"/>
                                                </svg>
                                                <span class="custom-tooltip">専用サポート
                                                    <div class="custom-tooltip-content">
                                                        すべてのステップで専任の技術サポートを受けられます。
                                                    </div>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="cardButton enterpriseButton ftButton">
                                    <a href="javascript:void(0)" data-toggle="modal" data-target="#EnterPriseContactPopup">お問い合わせ</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="pricingBoxcard" style="display: none;">
        <div class="container">
            <div class="row">
                <div class="col-lg-4">
                    <div class="pricingCardSection" style="box-shadow: none;border: solid 1px #f4f4f4;">
                        <div class="pricingCards boxShadowNone">
                            <div class="pricingBoxHeader">
                                <h2>ベーシック</h2>
                                <span>優れた英文ライティングを、すべての人に</span>
                            </div>
                            <div class="pricingToggleButton">
                                <h3>無料</h3>
                                <span style="font-size: 16px; font-weight: normal; font-style: italic; color: #4d4d4d">クレジットカード登録不要</span>
                            </div>
                            <div class="pricingButtons">
                                <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">今すぐ始める</a>
                            </div>
                        </div>
                        <div class="pricingPoints">
                            <ul>
                                <li>すべての機能 </li>
                                <li>1か月5000単語まで</li>
                                <li>毎月1回　 <span class="pricingboxTooltip pricingboxTooltipLess" alt="iThenticateが誇る最先端のテキスト類似性検出アルゴリズムと、最大級の有料出版物データベースによる高品質の盗用・剽窃チェック">盗用・剽窃スコア</span> が無料</li>
                                <li>盗用・剽窃チェック、 ファイル自動校正、さらに <span class="pricingboxTooltip pricingboxTooltipLess " alt="引用チェッカー、Journal Finder (近日公開)">その他</span>の機能を1か月合計4回まで利用可（組み合わせは自由。追加購入も可。）</li>
                                <!-- <li>
                                    <span class="pricingboxTooltip pricingboxTooltipLeft" alt="ご自宅、勤務先などいつもの環境で作成したWordファイルをアップロードすれば、Trinkaが数分で自動校正。変更履歴付きのファイルをダウンロードできます。">ファイル自動校正</span>
                                    、
                                    <span class="PublicationReadinessTooltip pricingboxTooltip" alt="アップロードした文章を、ジャーナルとの相性から、倫理面・コンプライアンスのチェックなど20以上のチェックポイントで査定し、論文受理の可能性を高めます。">
                                        出版適正チェックを</span> 1か月合計2回まで利用可（組み合わせは自由）
                                </li> -->
                                <!-- <li>1 Auto FIle Edit credit/month <span class="pricingboxTooltip"
                                    alt="Upload your MS Word document, let Trinka auto-edit your paper in minutes, and download your document with all changes tracked."><img
                                        src="../../../assets/images/info.svg" alt="icon"></span></li>
                            <li>1 Publication Readiness Checks/month <span
                                    class="PublicationReadinessTooltip pricingboxTooltip"
                                    alt="Evaluate your document on 20+ checkpoints, ranging from Journal Selection to Ethical Compliance, to increase your chances of getting published."><img
                                        src="../../../assets/images/info.svg" alt="icon"></span></li> -->
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5">
                    <div class="pricingCardSection">
                        <div class="pricingCards">
                            <div class="pricingBoxHeader">
                                <h2>プレミアム</h2>
                                <span>パワフルな英文ライティングを、無制限で</span>
                            </div>
                            <div class="pricingToggleButton">
                                <div class="premiumToggleButton switch switch--horizontal">
                                    <fieldset class="radio-switch">
                                        <input type="radio" name="checkPricing" id="MonthyCheck" (click)="monthyPricing()">
                                        <label for="MonthyCheck">月払い</label>

                                        <input type="radio" name="checkPricing" id="yearlyChecked" checked (click)="yearlyPricing()">
                                        <label for="yearlyChecked">
                                            年払い
                                            <span>67%お得</span>
                                        </label>
                                    </fieldset>
                                </div>
                                <div class="yearlyFinalPricing" *ngIf="monthfinalSection">
                                    <p>
                                        <sup class="OpenSansFonts">{{decodedData[0].currency}}</sup>
                                        <span class="OpenSansFonts">{{decodedData[0].amount| number:'1.2-2'}}</span>
                                        <sub>/1か月</sub>
                                    </p>
                                    <span>(毎月のお支払い)</span>
                                </div>
                                <div class="yearlyFinalPricing" *ngIf="YearlyfinalSection">
                                    <p>
                                        <sup class="OpenSansFonts">{{decodedData[0].currency}}</sup>
                                        <span class="OpenSansFonts">{{finalAmmount| number:'1.2-2'}}</span>
                                        <sub>/1か月</sub>
                                    </p>
                                    <span class="OpenSansFonts">({{decodedData[0].currency}} {{decodedData[2].final_amount| number:'1.2-2'}} billed yearly)</span>
                                </div>
                            </div>
                            <div class="pricingButtons">
                                <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">購入する</a>
                            </div>
                        </div>
                        <div class="pricingPoints">
                            <ul style="padding: 70px 30px 30px 40px">
                                <li>ベーシックプランの全機能</li>
                                <li>
                                    <span class="pricingboxTooltip powerModeTooptip" alt="最先端のAIにより、通常モードより最大40%多くの文法や文脈に基づく改善案を提示。プレミアムプランのファイル自動校正でご利用可能。近日中にTrinka Cloud、Wordアドイン、ブラウザプラグインでもご利用いただけます。">パワーモード (in Auto File Edit)</span>
                                </li>
                                <li>ご利用単語数の制限なし*</li>
                                <li>毎月2回 <span class="pricingboxTooltip" alt="iThenticateが誇る最先端のテキスト類似性検出アルゴリズムと、最大級の有料出版物データベースによる高品質の盗用・剽窃チェック">盗用・剽窃チェック</span> が無料</li>
                                <li>盗用・剽窃チェック、 ファイル自動校正、さらに <span class="pricingboxTooltip pricingboxTooltipLess pricingboxTooltipLeft" alt="引用チェッカー、Journal Finder (近日公開)">その他</span>の機能を1か月合計10回まで利用可（組み合わせは自由。追加購入も可。）</li>
                                <!-- <li>
                                    <span class="pricingboxTooltip pricingboxTooltipN" alt="ご自宅、勤務先などいつもの環境で作成したWordファイルをアップロードすれば、Trinkaが数分で自動校正。変更履歴付きのファイルをダウンロードできます。">
                                        ファイル自動校正、</span>
                                    <span class="paidTooltip pricingboxTooltip" alt="アップロードした文章を、ジャーナルとの相性から、倫理面・コンプライアンスのチェックなど20以上のチェックポイントで査定し、論文受理の可能性を高めます。">
                                        出版適正チェックを</span>
                                    <br /> 1か月合計5回まで利用可（組み合わせは自由。
                                    <br />追加購入も可。）
                                </li> -->
                                <li>新機能の先行利用可</li>
                                <!-- <li>3 Auto FIle Edit credits/month <span class="pricingboxTooltip"
                                        alt="Upload your MS Word document, let Trinka auto-edit your paper in minutes, and download your document with all changes tracked."><img
                                            src="../../../assets/images/info.svg" alt="icon"></span></li>
                                <li>3 Publication Readiness Checks/month <span class="pricingboxTooltip"
                                        alt="Evaluate your document on 20+ checkpoints, ranging from Journal Selection to Ethical Compliance, to increase your chances of getting published."><img
                                            src="../../../assets/images/info.svg" alt="icon"></span></li> -->
                                <!-- <li>MS Word Plug-in</li> -->

                            </ul>
                            <!-- <div class="pricingInUSD">
                                <p>Prices are in USD.</p>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="compareLinkAccess">
        <p (click)="scroll(target)">両プランの機能の比較</p>
        <a (click)="scroll(target)">
            <img src="../../../assets/images/PricingDownArrow.png" alt="icon">
        </a>
    </div>

    <div class="getYourTrinkaSections">
        <div class="container">
            <div class="row">
                <div class="col-lg-5">
                    <div class="trinkaGetPricing">
                        <div class="howItWorkHeading lineWhiteColor">
                            <h2>法人・機関の皆様には
                                <br />
                                <b class="OpenSansFonts">Trinka Enterprise</b>
                            </h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-7">
                    <div class="trinkaGetPricing">
                        <p>
                            <span class="OpenSansFonts">Trinka Enterprise
                            </span>では、Trinkaの全機能の無制限でのご利用と、貴社の製品やシステムに応じたカスタマイズが可能です。6人以上のチームでご利用の場合には、お得にご利用いただけます。
                        </p>
                        <a [routerLink]="['/enterprise']">もっと詳しく</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="pricingTableSectioni" #target>
        <div class="container" >
            <div class="row">
                <div class="col-12">
                    <div class="table-container" style="position: relative;">
                        <div class="mainContainer">
                            <div class="hiddenHeader"></div>
                            <table>
                                <thead>
                                    <!-- <tr>
                                        <th colspan="5"><div class="empty_div"></div></th>
                                    </tr> -->
                                    <tr class="in_line">
                                        <th colspan="6">
                                            <hr />
                                        </th>
                                    </tr>
                                    <tr>
                                        <th class="benefits_title">メリット</th>
                                        <th>
                                            <div class="pricingCardHeader">
                                                <div class="cardTop">
                                                    <h2>ベーシック</h2>
                                                    <div class="amount">
                                                        <div class="amt_div">
                                                            <b>{{decodedData[0].currency}}</b><h3>0</h3><span>/1か月</span>
                                                        </div>
                                                    </div>
                                                    <div class="infoContainer">
                                                        <p>無料</p>
                                                    </div>
                                                </div>
                                                <div class="cardButton">
                                                    <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">さっそく始める</a>
                                                </div>
                                            </div>
                                        </th>
                                        <th class="empty_th"></th>
                                        <th>
                                            <div class="pricingCardHeader premiumCardHeader">
                                                <div class="cardTop">
                                                    <h2>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M22.3741 8.70322L18.8221 3.34066C18.6809 3.12817 18.4423 3 18.1871 3H5.81368C5.55826 3 5.31983 3.12817 5.17863 3.34066L1.62667 8.70322C1.43714 8.98817 1.46244 9.36422 1.68821 9.62054L11.4273 20.7403C11.5712 20.9055 11.78 21 11.9999 21C12.2198 21 12.4286 20.9055 12.5732 20.7395L22.3123 9.61979C22.5373 9.3642 22.5626 8.98816 22.3741 8.70322ZM7.69844 9.88101L10.0589 16.8716L3.93597 9.88101H7.69844ZM13.7561 4.51844L14.7768 8.36335H9.22124L10.2419 4.51844H13.7561ZM14.6939 9.88101L11.9995 17.8627L9.30518 9.88101H14.6939ZM16.3007 9.88101H20.0634L13.9405 16.8716L16.3007 9.88101ZM20.3239 8.36253H16.3525L15.3318 4.51763H17.7775L20.3239 8.36253ZM6.22237 4.5184H8.6681L7.64741 8.3633H3.67506L6.22237 4.5184Z" fill="#7A28A0"/>
                                                        </svg>
                                                        プレミアム
                                                    </h2>
                                                    <div class="amount">
                                                        <div id="yearly" class="amt_div" *ngIf="isYearlyChecked; else monthlyContent">
                                                            <b>{{decodedData[0].currency}}</b>
                                                            <h3>{{decodedData[2].final_amount / 12 | number:'1.2-2'}}</h3>
                                                            <span>/1か月</span>
                                                            <!-- <b>$</b><h3>67</h3><span>per month</span> -->
                                                        </div>
                                                    </div>
                                                    <ng-template #monthlyContent>
                                                        <div id="monthly" class="amt_div">
                                                            <b>{{decodedData[0].currency}}</b>
                                                            <h3>{{decodedData[2].amount| number:'1.0-0'}}</h3>
                                                            <span>/1か月</span>
                                                            <!-- <b>$</b><h3>20</h3><span>per month</span> -->
                                                        </div>
                                                    </ng-template>
                                                    <div class="infoContainer">
                                                        <p *ngIf="isYearlyChecked" class="minHeight">年払い年額{{decodedData[0].currency}} {{decodedData[2].final_amount| number:'1.0-0'}}</p>
                                                        <p *ngIf="!isYearlyChecked" class="minHeight">請求済み {{decodedData[0].currency}} {{decodedData[2].amount| number:'1.0-0'}} 毎月</p>
                                                        <div class="pricingToggleButton">
                                                            <p>月払い</p>
                                                            <label class="switch" style="margin:0 8px;">
                                                                <input type="checkbox" checked [(ngModel)]="isYearlyChecked">
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <p>年払い <i *ngIf="isYearlyChecked">67%お得</i> </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="cardButton premiumButton">
                                                    <a *ngIf="isYearlyChecked" href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">アップグレードする</a>
                                                    <a *ngIf="!isYearlyChecked"href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">アップグレードする</a>
                                                </div>
                                            </div>
                                        </th>
                                        <th class="empty_th"></th>
                                        <th>
                                            <div class="pricingCardHeader premiumPlusCardHeader">
                                                <div class="cardTop">
                                                    <h2>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <path d="M21.8861 12.0695L18.6724 7.3028C18.5446 7.11393 18.3287 7 18.0978 7H6.90285C6.67176 7 6.45604 7.11393 6.32828 7.3028L3.1146 12.0695C2.94313 12.3228 2.96601 12.6571 3.17028 12.8849L11.9819 22.7691C12.112 22.916 12.3009 23 12.4999 23C12.6989 23 12.8878 22.916 13.0186 22.7685L21.8302 12.8843C22.0338 12.6571 22.0567 12.3228 21.8861 12.0695ZM8.60811 13.1165L10.7437 19.3303L5.20397 13.1165H8.60811ZM14.0888 8.34973L15.0123 11.7674H9.98588L10.9094 8.34973H14.0888ZM14.9373 13.1165L12.4996 20.2113L10.0618 13.1165H14.9373ZM16.3912 13.1165H19.7954L14.2557 19.3303L16.3912 13.1165ZM20.0311 11.7667H16.4379L15.5145 8.349H17.7273L20.0311 11.7667ZM7.27262 8.34969H9.48542L8.56194 11.7674H4.96791L7.27262 8.34969Z" fill="#FDE68A"/>
                                                            <path d="M6 1L6.81027 3.18973L9 4L6.81027 4.81027L6 7L5.18973 4.81027L3 4L5.18973 3.18973L6 1Z" fill="#FDE68A"/>
                                                            <path d="M3 6L3.54018 7.45982L5 8L3.54018 8.54018L3 10L2.45982 8.54018L1 8L2.45982 7.45982L3 6Z" fill="#FDE68A"/>
                                                        </svg>
                                                        プレミアムプラス
                                                    </h2>
                                                    <div class="amount">
                                                        <div class="amt_div">
                                                            <b>{{decodedData[0].currency}}</b>
                                                            <h3 class="text-white">{{decodedData[3].amount | number:'1.2-2'}}</h3>
                                                            <span>/1か月</span>
                                                            <!-- <b>$</b><h3>8.33</h3><span>per month</span> -->
                                                        </div>
                                                    </div>
                                                    <div class="infoContainer">
                                                        <p>年払い年額{{decodedData[0].currency}}{{decodedData[3].final_amount | number:'1.0-0'}}</p>
                                                        <span>盗用・剽窃チェック利用の度に最大{{decodedData[0].currency}}{{decodedData[0].currency=='$'?'36 ':'2880 '}}お得に</span>
                                                    </div>
                                                </div>
                                                <div class="cardButton premiumPlusButton">
                                                    <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank">アップグレードする</a>
                                                </div>
                                            </div>
                                        </th>
                                    </tr>
                                    <tr class="in_line">
                                        <th colspan="6">
                                            <hr />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- Start Grammar and Language -->
                                    <tr class="noBorder">
                                        <td colspan="5">
                                            <h3 class="middleTitle"><span></span> 文法と言語</h3>
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.75 3.93945C3.55109 3.93945 3.36032 4.01847 3.21967 4.15912C3.07902 4.29978 3 4.49054 3 4.68945C3 4.88837 3.07902 5.07913 3.21967 5.21978C3.36032 5.36044 3.55109 5.43945 3.75 5.43945H20.25C20.4489 5.43945 20.6397 5.36044 20.7803 5.21978C20.921 5.07913 21 4.88837 21 4.68945C21 4.49054 20.921 4.29978 20.7803 4.15912C20.6397 4.01847 20.4489 3.93945 20.25 3.93945H3.75ZM6.66 18.092L7.314 17.4395H3.75C3.55109 17.4395 3.36032 17.5185 3.21967 17.6591C3.07902 17.7998 3 17.9905 3 18.1895C3 18.3884 3.07902 18.5791 3.21967 18.7198C3.36032 18.8604 3.55109 18.9395 3.75 18.9395H6.126C6.234 18.6305 6.4125 18.3395 6.66 18.092ZM10.4595 14.297C10.1522 14.1813 9.87391 13.9999 9.64408 13.7654C9.41426 13.5309 9.23846 13.249 9.129 12.9395H3.75C3.55109 12.9395 3.36032 13.0185 3.21967 13.1591C3.07902 13.2998 3 13.4905 3 13.6895C3 13.8884 3.07902 14.0791 3.21967 14.2198C3.36032 14.3604 3.55109 14.4395 3.75 14.4395H10.317L10.4595 14.297ZM11.112 9.93945L11.52 9.88845C11.6829 9.82511 11.8185 9.70688 11.9035 9.55417C11.9885 9.40146 12.0175 9.22387 11.9855 9.05206C11.9535 8.88026 11.8625 8.72503 11.7282 8.61318C11.5939 8.50133 11.4248 8.43988 11.25 8.43945H3.75C3.55109 8.43945 3.36032 8.51847 3.21967 8.65912C3.07902 8.79978 3 8.99054 3 9.18945C3 9.38837 3.07902 9.57913 3.21967 9.71978C3.36032 9.86044 3.55109 9.93945 3.75 9.93945H11.112ZM15.75 6.93945C15.933 6.93955 16.1096 7.00655 16.2467 7.12784C16.3837 7.24912 16.4717 7.41632 16.494 7.59795L16.629 8.69895C16.711 9.36289 17.0125 9.98038 17.4857 10.4533C17.9589 10.9262 18.5765 11.2274 19.2405 11.309L20.3415 11.444C20.5238 11.4656 20.6918 11.5534 20.8137 11.6907C20.9356 11.8279 21.0029 12.0051 21.0029 12.1887C21.0029 12.3723 20.9356 12.5495 20.8137 12.6867C20.6918 12.824 20.5238 12.9118 20.3415 12.9335L19.2405 13.0685C18.5766 13.1504 17.9591 13.452 17.4862 13.9251C17.0133 14.3983 16.7121 15.016 16.6305 15.68L16.4955 16.781C16.4738 16.9632 16.386 17.1312 16.2488 17.2531C16.1115 17.375 15.9343 17.4424 15.7507 17.4424C15.5672 17.4424 15.39 17.375 15.2527 17.2531C15.1155 17.1312 15.0277 16.9632 15.006 16.781L14.871 15.68C14.789 15.016 14.4875 14.3985 14.0143 13.9256C13.5411 13.4527 12.9235 13.1515 12.2595 13.07L11.1585 12.935C10.9762 12.9133 10.8082 12.8255 10.6863 12.6882C10.5644 12.551 10.4971 12.3738 10.4971 12.1902C10.4971 12.0066 10.5644 11.8294 10.6863 11.6922C10.8082 11.5549 10.9762 11.4671 11.1585 11.4455L12.2595 11.3105C12.9234 11.2285 13.5409 10.9269 14.0138 10.4538C14.4867 9.9806 14.7879 9.36294 14.8695 8.69895L15.0045 7.59795C15.0269 7.41607 15.115 7.24866 15.2524 7.12734C15.3897 7.00602 15.5667 6.93918 15.75 6.93945ZM15.75 10.6505C15.3705 11.2805 14.841 11.81 14.211 12.1895C14.841 12.569 15.3705 13.0985 15.75 13.7285C16.1295 13.0985 16.659 12.569 17.289 12.1895C16.6581 11.8098 16.1297 11.2814 15.75 10.6505ZM13.281 14.66C13.4216 14.8006 13.5006 14.9913 13.5006 15.1902C13.5006 15.3891 13.4216 15.5798 13.281 15.7205L8.781 20.2145C8.71181 20.2861 8.62906 20.3432 8.53755 20.3825C8.44605 20.4218 8.34764 20.4425 8.24805 20.4434C8.14847 20.4443 8.04971 20.4253 7.95753 20.3876C7.86536 20.3499 7.78162 20.2942 7.7112 20.2237C7.64078 20.1533 7.58509 20.0696 7.54738 19.9774C7.50967 19.8852 7.4907 19.7865 7.49156 19.6869C7.49243 19.5873 7.51312 19.4889 7.55242 19.3974C7.59173 19.3059 7.64887 19.2231 7.7205 19.154L12.2205 14.6585C12.3611 14.5178 12.5519 14.4389 12.7507 14.4389C12.9496 14.4389 13.1404 14.5178 13.281 14.6585V14.66Z" fill="#7A28A0"/>
                                                </svg>
                                                使用制限
                                            </h5>
                                            <span>高度な言語チェックと改善提案</span>
                                        </td>
                                        <td>
                                            20,000単語/月
                                        </td>
                                        <td></td>
                                        <td>
                                            無制限 *
                                        </td>
                                        <td></td>
                                        <td>
                                            無制限 *
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M4.5 4.60547L1.95117 12H0.410156L3.62109 3.46875H4.60547L4.5 4.60547ZM6.63281 12L4.07812 4.60547L3.9668 3.46875H4.95703L8.17969 12H6.63281ZM6.50977 8.83594V10.002H1.86914V8.83594H6.50977ZM12.334 8.14453H10.1602L10.1484 7.07227H12.0469C12.3672 7.07227 12.6387 7.02539 12.8613 6.93164C13.0879 6.83398 13.2598 6.69531 13.377 6.51562C13.4941 6.33203 13.5527 6.11133 13.5527 5.85352C13.5527 5.56836 13.498 5.33594 13.3887 5.15625C13.2793 4.97656 13.1113 4.8457 12.8848 4.76367C12.6621 4.68164 12.377 4.64062 12.0293 4.64062H10.6055V12H9.13477V3.46875H12.0293C12.498 3.46875 12.916 3.51367 13.2832 3.60352C13.6543 3.69336 13.9688 3.83398 14.2266 4.02539C14.4883 4.21289 14.6855 4.45117 14.8184 4.74023C14.9551 5.0293 15.0234 5.37305 15.0234 5.77148C15.0234 6.12305 14.9395 6.44531 14.7715 6.73828C14.6035 7.02734 14.3555 7.26367 14.0273 7.44727C13.6992 7.63086 13.291 7.74023 12.8027 7.77539L12.334 8.14453ZM12.2695 12H9.69727L10.3594 10.834H12.2695C12.6016 10.834 12.8789 10.7793 13.1016 10.6699C13.3242 10.5566 13.4902 10.4023 13.5996 10.207C13.7129 10.0078 13.7695 9.77539 13.7695 9.50977C13.7695 9.23242 13.7207 8.99219 13.623 8.78906C13.5254 8.58203 13.3711 8.42383 13.1602 8.31445C12.9492 8.20117 12.6738 8.14453 12.334 8.14453H10.6816L10.6934 7.07227H12.8438L13.1777 7.47656C13.6465 7.49219 14.0312 7.5957 14.332 7.78711C14.6367 7.97852 14.8633 8.22656 15.0117 8.53125C15.1602 8.83594 15.2344 9.16406 15.2344 9.51562C15.2344 10.0586 15.1152 10.5137 14.877 10.8809C14.6426 11.248 14.3047 11.5273 13.8633 11.7188C13.4219 11.9062 12.8906 12 12.2695 12ZM21.7559 9.22266H23.2207C23.1738 9.78125 23.0176 10.2793 22.752 10.7168C22.4863 11.1504 22.1133 11.4922 21.6328 11.7422C21.1523 11.9922 20.5684 12.1172 19.8809 12.1172C19.3535 12.1172 18.8789 12.0234 18.457 11.8359C18.0352 11.6445 17.6738 11.375 17.373 11.0273C17.0723 10.6758 16.8418 10.252 16.6816 9.75586C16.5254 9.25977 16.4473 8.70508 16.4473 8.0918V7.38281C16.4473 6.76953 16.5273 6.21484 16.6875 5.71875C16.8516 5.22266 17.0859 4.79883 17.3906 4.44727C17.6953 4.0918 18.0605 3.82031 18.4863 3.63281C18.916 3.44531 19.3984 3.35156 19.9336 3.35156C20.6133 3.35156 21.1875 3.47656 21.6562 3.72656C22.125 3.97656 22.4883 4.32227 22.7461 4.76367C23.0078 5.20508 23.168 5.71094 23.2266 6.28125H21.7617C21.7227 5.91406 21.6367 5.59961 21.5039 5.33789C21.375 5.07617 21.1836 4.87695 20.9297 4.74023C20.6758 4.59961 20.3438 4.5293 19.9336 4.5293C19.5977 4.5293 19.3047 4.5918 19.0547 4.7168C18.8047 4.8418 18.5957 5.02539 18.4277 5.26758C18.2598 5.50977 18.1328 5.80859 18.0469 6.16406C17.9648 6.51562 17.9238 6.91797 17.9238 7.37109V8.0918C17.9238 8.52148 17.9609 8.91211 18.0352 9.26367C18.1133 9.61133 18.2305 9.91016 18.3867 10.1602C18.5469 10.4102 18.75 10.6035 18.9961 10.7402C19.2422 10.877 19.5371 10.9453 19.8809 10.9453C20.2988 10.9453 20.6367 10.8789 20.8945 10.7461C21.1562 10.6133 21.3535 10.4199 21.4863 10.166C21.623 9.9082 21.7129 9.59375 21.7559 9.22266Z" fill="#7A28A0"/>
                                                    <path d="M10.4004 18.5844L13.0658 21.5996L18.8004 15.5996" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                高度な文法チェック
                                            </h5>
                                            <span>高度な言語チェックと改善提案</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.56836 12.165H4.18896L3.54883 13.6475C3.33919 14.1416 3.23438 14.5496 3.23438 14.8716C3.23438 15.2983 3.40658 15.6128 3.75098 15.8149C3.95312 15.9347 4.45101 16.0246 5.24463 16.0845V16.5H0.179688V16.0845C0.726237 16.0021 1.17546 15.7775 1.52734 15.4106C1.87923 15.0363 2.31348 14.2689 2.83008 13.1084L8.27686 0.957031H8.49023L13.9819 13.4453C14.506 14.6283 14.9365 15.3732 15.2734 15.6802C15.528 15.9123 15.8874 16.047 16.3516 16.0845V16.5H8.98438V16.0845H9.2876C9.87907 16.0845 10.2946 16.0021 10.5342 15.8374C10.6989 15.7176 10.7812 15.5454 10.7812 15.3208C10.7812 15.186 10.7588 15.0475 10.7139 14.9053C10.6989 14.8379 10.5866 14.5571 10.377 14.063L9.56836 12.165ZM9.18652 11.334L6.91797 6.08936L4.58203 11.334H9.18652Z" fill="#7A28A0"/>
                                                    <path d="M19.9922 22.2383H17.1855L16.8516 23.0117C16.7422 23.2695 16.6875 23.4824 16.6875 23.6504C16.6875 23.873 16.7773 24.0371 16.957 24.1426C17.0625 24.2051 17.3223 24.252 17.7363 24.2832V24.5H15.0938V24.2832C15.3789 24.2402 15.6133 24.123 15.7969 23.9316C15.9805 23.7363 16.207 23.3359 16.4766 22.7305L19.3184 16.3906H19.4297L22.2949 22.9062C22.5684 23.5234 22.793 23.9121 22.9688 24.0723C23.1016 24.1934 23.2891 24.2637 23.5312 24.2832V24.5H19.6875V24.2832H19.8457C20.1543 24.2832 20.3711 24.2402 20.4961 24.1543C20.582 24.0918 20.625 24.002 20.625 23.8848C20.625 23.8145 20.6133 23.7422 20.5898 23.668C20.582 23.6328 20.5234 23.4863 20.4141 23.2285L19.9922 22.2383ZM19.793 21.8047L18.6094 19.0684L17.3906 21.8047H19.793Z" fill="#7A28A0"/>
                                                </svg>
                                                スタイルガイドの設定
                                            </h5>
                                            <span>APA、AMA、ACS、AGU、IEEEからスタイルガイドを選択</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M6 15.4395L12 3.43945L18 15.4395M8 11.4395H16M16 19.4395L18 21.4395L22 17.4395" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                文脈に応じたスペルチェック
                                            </h5>
                                            <span>テーマに基づいた専門用語および一般語句のスペルチェック</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M13.5 5.93976L17.5 9.93976M4 19.4398H8L18.5 8.93976C18.7626 8.67711 18.971 8.36531 19.1131 8.02215C19.2553 7.67899 19.3284 7.31119 19.3284 6.93976C19.3284 6.56832 19.2553 6.20052 19.1131 5.85736C18.971 5.5142 18.7626 5.2024 18.5 4.93976C18.2374 4.67711 17.9256 4.46877 17.5824 4.32663C17.2392 4.18449 16.8714 4.11133 16.5 4.11133C16.1286 4.11133 15.7608 4.18449 15.4176 4.32663C15.0744 4.46877 14.7626 4.67711 14.5 4.93976L4 15.4398V19.4398Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                語調の補正
                                            </h5>
                                            <span>フォーマルな文体への改定</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M12 4.5H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M12 9.5H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M21 14.5H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M21 19.5H3" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                文構造の修正
                                            </h5>
                                            <span>分野に基づき、文章を分かりやすく構成</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M7 8.89039C10.15 7.32039 13.85 7.32039 17 8.89039" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M12 16.2997V7.92969" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                適切な専門用語の選択
                                            </h5>
                                            <span>分野に即した、よりインパクトのある言葉の提案</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M20.4233 17.7135L15 10.2563V3H16.5V1.5H7.50002V3H9.00002V10.2563L3.57677 17.7135C3.24965 18.1631 3.05328 18.6944 3.0094 19.2487C2.96552 19.8029 3.07584 20.3585 3.32815 20.854C3.58046 21.3495 3.96492 21.7655 4.43899 22.056C4.91307 22.3465 5.45827 22.5001 6.01427 22.5H17.985C18.541 22.5001 19.0862 22.3465 19.5603 22.056C20.0344 21.7655 20.4188 21.3495 20.6711 20.854C20.9235 20.3585 21.0338 19.8029 20.9899 19.2487C20.946 18.6944 20.7496 18.1631 20.4225 17.7135H20.4233ZM10.5 10.7437V3H13.5V10.7437L15.5048 13.5H8.49527L10.5 10.7437ZM17.9858 21H6.01502C5.73587 20.9997 5.46222 20.9223 5.22429 20.7763C4.98635 20.6303 4.79339 20.4214 4.66669 20.1726C4.53999 19.9239 4.48448 19.645 4.50628 19.3666C4.52809 19.0883 4.62637 18.8215 4.79027 18.5955L7.40477 15H16.5953L19.2105 18.5955C19.3744 18.8215 19.4727 19.0883 19.4945 19.3666C19.5163 19.645 19.4608 19.9239 19.3341 20.1726C19.2074 20.4214 19.0144 20.6303 18.7765 20.7763C18.5386 20.9223 18.2649 20.9997 17.9858 21Z" fill="#7A28A0"/>
                                                </svg>
                                                分野に即した修正提案
                                            </h5>
                                            <span>医学、生命科学、物理学、工学、社会科学など</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>
                                    <!-- End Grammar and Language -->

                                    <!-- start Paraphraser -->
                                    <tr class="noBorder">
                                        <td colspan="5">
                                            <h3 class="middleTitle"><span></span> パラフレーズ機能</h3>
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M21 5.25H14C13.59 5.25 13.25 4.91 13.25 4.5C13.25 4.09 13.59 3.75 14 3.75H21C21.41 3.75 21.75 4.09 21.75 4.5C21.75 4.91 21.41 5.25 21 5.25Z" fill="#7A28A0"/>
                                                    <path d="M21 10.25H14C13.59 10.25 13.25 9.91 13.25 9.5C13.25 9.09 13.59 8.75 14 8.75H21C21.41 8.75 21.75 9.09 21.75 9.5C21.75 9.91 21.41 10.25 21 10.25Z" fill="#7A28A0"/>
                                                    <path d="M21 15.25H3C2.59 15.25 2.25 14.91 2.25 14.5C2.25 14.09 2.59 13.75 3 13.75H21C21.41 13.75 21.75 14.09 21.75 14.5C21.75 14.91 21.41 15.25 21 15.25Z" fill="#7A28A0"/>
                                                    <path d="M21 20.25H3C2.59 20.25 2.25 19.91 2.25 19.5C2.25 19.09 2.59 18.75 3 18.75H21C21.41 18.75 21.75 19.09 21.75 19.5C21.75 19.91 21.41 20.25 21 20.25Z" fill="#7A28A0"/>
                                                    <path d="M7.92 10.75H5.08C3.54 10.75 2.75 9.97 2.75 8.42V5.58C2.75 4.04 3.53 3.25 5.08 3.25H7.93C9.47 3.25 10.26 4.03 10.26 5.58V8.43C10.25 9.97 9.47 10.75 7.92 10.75ZM5.08 4.75C4.37 4.75 4.25 4.87 4.25 5.58V8.43C4.25 9.14 4.37 9.26 5.08 9.26H7.93C8.64 9.26 8.76 9.14 8.76 8.43V5.58C8.76 4.87 8.64 4.75 7.93 4.75H5.08Z" fill="#7A28A0"/>
                                                </svg>
                                                パラフレーズ機能
                                            </h5>
                                            <span>元の意味を保持した一貫性のあるパラフレーズ</span>
                                        </td>
                                        <td>
                                            5000単語/月
                                        </td>
                                        <td></td>
                                        <td>
                                            無制限
                                        </td>
                                        <td></td>
                                        <td>
                                            無制限
                                        </td>
                                    </tr>
                                    <!-- End Paraphraser -->

                                    <!-- Start Access Points -->
                                    <tr class="noBorder">
                                        <td colspan="5">
                                            <h3 class="middleTitle"><span></span> 使用方法</h3>
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_734_25687)">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.99998 9.85616C5.01804 8.3401 5.56552 6.87804 6.54768 5.72299C7.52984 4.56793 8.88488 3.79256 10.3783 3.53103C11.8718 3.26951 13.4097 3.53829 14.7259 4.29086C16.0421 5.04343 17.0538 6.23245 17.586 7.65216C18.9853 8.03806 20.1973 8.91798 20.9976 10.129C21.7979 11.3399 22.1323 12.7999 21.9387 14.2385C21.7452 15.6771 21.0369 16.9968 19.9449 17.9531C18.853 18.9095 17.4515 19.4378 16 19.4402H6.99998C5.85069 19.4409 4.73623 19.0457 3.84417 18.3211C2.95212 17.5964 2.33693 16.5866 2.10215 15.4616C1.86737 14.3365 2.02734 13.1649 2.55513 12.144C3.08292 11.1231 3.94631 10.3151 4.99998 9.85616ZM11.5 5.44016C10.8668 5.44004 10.2407 5.57355 9.66259 5.83198C9.08452 6.0904 8.56749 6.46791 8.1453 6.93984C7.72312 7.41177 7.40528 7.96748 7.21257 8.57065C7.01987 9.17382 6.95662 9.81087 7.02698 10.4402C7.05366 10.6828 6.99159 10.9268 6.85224 11.1272C6.71289 11.3276 6.5057 11.4707 6.26898 11.5302C5.56191 11.7114 4.94508 12.144 4.53389 12.747C4.12269 13.3501 3.9453 14.0823 4.0349 14.8067C4.1245 15.5311 4.47495 16.198 5.02069 16.6827C5.56643 17.1674 6.27008 17.4367 6.99998 17.4402H16C17.005 17.4417 17.9738 17.0648 18.7136 16.3845C19.4534 15.7042 19.9099 14.7704 19.9925 13.7687C20.0751 12.7671 19.7775 11.7711 19.1591 10.9789C18.5407 10.1866 17.6467 9.65622 16.655 9.49316C16.464 9.46159 16.2862 9.37581 16.1426 9.24604C15.999 9.11626 15.8957 8.94796 15.845 8.76116C15.5857 7.80742 15.0198 6.9655 14.2345 6.36531C13.4493 5.76512 12.4883 5.44002 11.5 5.44016Z" fill="#7A28A0"/>
                                                    </g>
                                                    <defs>
                                                    <clipPath id="clip0_734_25687">
                                                    <rect width="24" height="24" fill="white"/>
                                                    </clipPath>
                                                    </defs>
                                                </svg>
                                                Trinka Cloud</h5>
                                            <span>オンライン文書エディター</span>
                                        </td>
                                        <td>単語数上限あり</td>
                                        <td></td>
                                        <td>無制限 *</td>
                                        <td></td>
                                        <td>無制限 *</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <g clip-path="url(#clip0_2178_64496)">
                                                    <path d="M19.0968 2.04793H11.8088V0.230469H10.4503L0 2.05246V17.9505L10.3889 19.768H11.8088V17.9573H18.6287C19.015 17.9391 19.4443 17.9687 19.776 17.7324C20.0418 17.3258 19.9737 16.8169 19.9964 16.358V2.92938C20.0441 2.41141 19.6147 1.99566 19.0968 2.04793ZM7.57871 13.0866C7.19934 13.2843 6.63137 13.0775 6.18156 13.1093C5.87941 11.6054 5.52727 10.1105 5.25695 8.5998C4.99113 10.0674 4.64582 11.5213 4.34141 12.9798C3.90523 12.9571 3.4668 12.9298 3.02832 12.9003C2.65117 10.9011 2.2082 8.91555 1.85605 6.91184C2.24453 6.89367 2.63527 6.87777 3.02375 6.86414C3.25773 8.31129 3.52355 9.7516 3.72805 11.201C4.04836 9.71523 4.37547 8.22949 4.69355 6.74375C5.1252 6.71875 5.55684 6.70059 5.98848 6.67785C6.29062 8.21133 6.59957 9.7425 6.92672 11.2691C7.18344 9.69254 7.46738 8.12043 7.7423 6.54609C8.19664 6.5302 8.65102 6.5052 9.10309 6.47793C8.58969 8.6793 8.13984 10.8989 7.57871 13.0866ZM18.9151 16.8784H11.8088V15.4515H17.7155V14.5428H11.8088V13.4069H17.7155V12.4982H11.8088V11.3623H17.7155V10.4536H11.8088V9.31766H17.7155V8.40898H11.8088V7.27305H17.7155V6.36434H11.8088V5.22844H17.7155V4.31973H11.8088V3.12012H18.9151V16.8784Z" fill="#7A28A0"/>
                                                    </g>
                                                    <defs>
                                                    <clipPath id="clip0_2178_64496">
                                                        <rect width="20" height="20" fill="white"/>
                                                    </clipPath>
                                                    </defs>
                                                </svg>
                                                MS Wordアドイン
                                            </h5>
                                            <span>MacおよびWindows OSのMS Wordで</span>
                                        </td>
                                        <td><img src="../../../assets/images/close-circle.svg" alt="close"></td>
                                        <td></td>
                                        <td>無制限 *</td>
                                        <td></td>
                                        <td>無制限 *</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M7.99998 3H8.99998C7.04998 8.84 7.04998 15.16 8.99998 21H7.99998" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M15 3C16.95 8.84 16.95 15.16 15 21" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M3 16V15C8.84 16.95 15.16 16.95 21 15V16" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M3 8.99961C8.84 7.04961 15.16 7.04961 21 8.99961" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                ブラウザプラグイン
                                            </h5>
                                            <span>Chrome、Edge、Firefox用ブラウザプラグイン</span>
                                        </td>
                                        <td>単語数上限あり</td>
                                        <td></td>
                                        <td>無制限 *</td>
                                        <td></td>
                                        <td>無制限 *</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <g clip-path="url(#clip0_734_25715)">
                                                    <path d="M23.06 15.3328L20.34 11.9995L23.0067 8.73284C23.1525 8.55414 23.2444 8.33756 23.2716 8.10849C23.2987 7.87943 23.26 7.64736 23.16 7.43951C23.0587 7.20653 22.8906 7.00877 22.6771 6.87115C22.4635 6.73353 22.214 6.66221 21.96 6.66618H1.29333C1.12611 6.66353 0.960006 6.69385 0.804504 6.75541C0.649001 6.81696 0.507149 6.90855 0.387048 7.02494C0.266946 7.14132 0.170949 7.28023 0.104539 7.43372C0.0381284 7.58721 0.0026059 7.75229 0 7.91951L0 16.0862C0.00700716 16.4227 0.147001 16.7428 0.389366 16.9764C0.631732 17.2101 0.956746 17.3382 1.29333 17.3328H22.0333C22.2789 17.3369 22.5204 17.2707 22.7295 17.1419C22.9386 17.0132 23.1065 16.8273 23.2133 16.6062C23.3093 16.4008 23.3458 16.1726 23.3187 15.9476C23.2916 15.7225 23.202 15.5096 23.06 15.3328ZM1.33333 15.9995V7.99951H21.8533L18.6267 11.9528L21.9 15.9995H1.33333Z" fill="#7A28A0"/>
                                                    <path d="M6.26004 12.9L4.08671 10H3.33337V14.12H4.08671V11.2267L6.26004 14.12H7.00671V10H6.26004V12.9Z" fill="#7A28A0"/>
                                                    <path d="M8.12 14.12H11.2267V13.44H8.87333V12.3667H11V11.68H8.87333V10.6867H11.2267V10H8.12V14.12Z" fill="#7A28A0"/>
                                                    <path d="M16.3467 12.9533L15.3733 10H14.56L13.58 12.9533L12.7 10H11.88L13.1867 14.12H13.9267L14.9667 11.06L16 14.12H16.7533L18.0533 10H17.2333L16.3467 12.9533Z" fill="#7A28A0"/>
                                                    </g>
                                                    <defs>
                                                    <clipPath id="clip0_734_25715">
                                                    <rect width="24" height="24" fill="white"/>
                                                    </clipPath>
                                                    </defs>
                                                </svg>
                                                新機能への先行アクセス
                                            </h5>
                                            <span>新機能を先行してご利用いただけます</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/close-circle.svg" alt="close">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <!-- Access Points End -->

                                    <!-- Start Plagiarism -->
                                    <tr class="noBorder">
                                        <td colspan="5">
                                            <h3 class="middleTitle"><span></span> 盗用・剽窃チェック</h3>
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M14.6039 10.9451C16.9247 10.9451 18.7813 12.7106 18.7813 14.9176C18.7813 15.6945 18.5493 16.4272 18.1408 17.0363L21 19.7729L19.7096 21L16.8133 18.2898C16.1728 18.6694 15.4116 18.8901 14.6039 18.8901C12.2831 18.8901 10.4265 17.1246 10.4265 14.9176C10.4265 12.7106 12.2831 10.9451 14.6039 10.9451ZM14.6039 12.7106C13.9884 12.7106 13.3981 12.9432 12.9629 13.357C12.5276 13.7709 12.2831 14.3323 12.2831 14.9176C12.2831 15.5029 12.5276 16.0643 12.9629 16.4782C13.3981 16.8921 13.9884 17.1246 14.6039 17.1246C15.2194 17.1246 15.8097 16.8921 16.245 16.4782C16.6802 16.0643 16.9247 15.5029 16.9247 14.9176C16.9247 14.3323 16.6802 13.7709 16.245 13.357C15.8097 12.9432 15.2194 12.7106 14.6039 12.7106ZM4.85663 3H17.853C18.8834 3 19.7096 3.78568 19.7096 4.76557V11.8543C19.2455 11.1481 18.605 10.539 17.853 10.0623V4.76557H4.85663V17.1246H9.03404C9.32182 17.7867 9.73956 18.3781 10.2501 18.8901H4.85663C3.8262 18.8901 3 18.1045 3 17.1246V4.76557C3 3.78568 3.8262 3 4.85663 3ZM6.71325 6.53114H15.9964V8.29671H6.71325V6.53114ZM6.71325 10.0623H11.3827C10.64 10.5037 9.99948 11.1128 9.4982 11.8279H6.71325V10.0623ZM6.71325 13.5934H8.72769C8.62558 14.0348 8.56988 14.4762 8.56988 14.9176V15.359H6.71325V13.5934Z" fill="#7A28A0"/>
                                                </svg>
                                                iThenticate® 盗用・剽窃レポート
                                            </h5>
                                            <span>iThenticateによる高品質の盗用・剽窃チェック</span>
                                        </td>
                                        <td>
                                            ポイント (Credit )利用
                                        </td>
                                        <td></td>
                                        <td>
                                            ポイント (Credit )利用
                                        </td>
                                        <td></td>
                                        <td>
                                            ポイント (Credit )利用
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <rect width="24" height="24" fill="white"/>
                                                    <path d="M6 17.4395V4.43945C6 3.33488 6.89543 2.43945 8 2.43945H14.6624C15.2614 2.43945 15.8289 2.70798 16.2088 3.17118L18.5464 6.02155C18.8397 6.37915 19 6.82734 19 7.28982V17.4395C19 18.544 18.1046 19.4395 17 19.4395H8C6.89543 19.4395 6 18.544 6 17.4395Z" stroke="#7A28A0" stroke-width="1.5"/>
                                                    <path d="M3 11.4395L22 11.4395" stroke="#7A28A0" stroke-linecap="round"/>
                                                    <path d="M3 10.4395L22 10.4395" stroke="white" stroke-linecap="round"/>
                                                    <path d="M3 12.4395L22 12.4395" stroke="white" stroke-linecap="round"/>
                                                    <path d="M14 4.30664V6.30664C14 6.85893 14.4477 7.30664 15 7.30664H17" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                                </svg>
                                                Trinka 盗用・剽窃レポート
                                            </h5>
                                            <span>インターネットソースと一部のオープンアクセス記事との照合</span>
                                        </td>
                                        <td>
                                            ポイント (Credit )利用
                                        </td>
                                        <td></td>
                                        <td>
                                            ポイント (Credit )利用
                                        </td>
                                        <td></td>
                                        <td>
                                            無制限 *
                                        </td>
                                    </tr>

                                    <!-- <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <rect width="24" height="24" fill="white"/>
                                                    <mask id="path-1-inside-1_2178_64553" fill="white">
                                                    <rect x="6" y="6" width="9" height="9" rx="1"/>
                                                    </mask>
                                                    <rect x="6" y="6" width="9" height="9" rx="1" stroke="#7A28A0" stroke-width="3" mask="url(#path-1-inside-1_2178_64553)"/>
                                                    <path d="M10.5 14.5V17.5" stroke="#7A28A0" stroke-width="1.5"/>
                                                    <path d="M10.5 3V6" stroke="#7A28A0" stroke-width="1.5"/>
                                                    <path d="M10.5 14.5V17.5" stroke="#7A28A0" stroke-width="1.5"/>
                                                    <path d="M10.5 3V6" stroke="#7A28A0" stroke-width="1.5"/>
                                                    <path d="M10.5 14.5V17.5" stroke="#7A28A0" stroke-width="1.5"/>
                                                    <path d="M10.5 3V6" stroke="#7A28A0" stroke-width="1.5"/>
                                                    <path d="M10.5 14.5V17.5" stroke="#7A28A0" stroke-width="1.5"/>
                                                    <path d="M10.5 3V6" stroke="#7A28A0" stroke-width="1.5"/>
                                                    <path d="M14.5 10.25L17.5 10.25" stroke="#7A28A0" stroke-width="1.5"/>
                                                    <path d="M3 10.25L6 10.25" stroke="#7A28A0" stroke-width="1.5"/>
                                                    <path d="M6.5 8.5L3.72265 6.64843C3.58355 6.5557 3.5 6.39958 3.5 6.23241V3M6.5 13L3.77639 14.3618C3.607 14.4465 3.5 14.6196 3.5 14.809V17.5" stroke="#7A28A0"/>
                                                    <path d="M14 8.5L16.7774 6.64843C16.9164 6.5557 17 6.39958 17 6.23241V3M14 13L16.7236 14.3618C16.893 14.4465 17 14.6196 17 14.809V17.5" stroke="#7A28A0"/>
                                                    <circle cx="3.5" cy="2.5" r="1" stroke="#7A28A0"/>
                                                    <circle cx="10.5" cy="2.5" r="1" stroke="#7A28A0"/>
                                                    <circle cx="10.5" cy="18.5" r="1" stroke="#7A28A0"/>
                                                    <circle cx="18.5" cy="10.5" r="1" stroke="#7A28A0"/>
                                                    <circle cx="2.5" cy="10.5" r="1" stroke="#7A28A0"/>
                                                    <circle cx="17.5" cy="2.5" r="1" stroke="#7A28A0"/>
                                                    <circle cx="3.5" cy="18.5" r="1" stroke="#7A28A0"/>
                                                    <circle cx="17.5" cy="18.5" r="1" stroke="#7A28A0"/>
                                                </svg>
                                                AI生成コンテンツ検出
                                            </h5>
                                            <span>ChatGPT等の大規模言語モデルによって生成されたコンテンツを検出</span>
                                        </td>
                                        <td>
                                            Trinka 盗用・剽窃レポートで<br/>利用可能
                                        </td>
                                        <td></td>
                                        <td>
                                            Trinka 盗用・剽窃レポートで<br/>利用可能
                                        </td>
                                        <td></td>
                                        <td>
                                            無制限 access
                                        </td>
                                    </tr> -->

                                    <!-- End Start Plagiarism -->

                                    <!-- Start AI reports -->
                                    <tr class="noBorder">
                                        <td colspan="5">
                                            <h3 class="middleTitle"><span></span> AIレポート</h3>
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M9.31055 14.6992L10.8105 16.1992L14.8105 12.1992" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M16 4.01953C19.33 4.19953 21 5.42953 21 9.99953V15.9995C21 19.9995 20 21.9995 15 21.9995H9C4 21.9995 3 19.9995 3 15.9995V9.99953C3 5.43953 4.67 4.19953 8 4.01953" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                ファイル自動校正
                                            </h5>
                                            <span>文書を数分で校正、変更履歴付きファイルをダウンロード</span>
                                        </td>
                                        <td>
                                            ポイント (Credit )利用
                                        </td>
                                        <td></td>
                                        <td>
                                            ポイント (Credit )利用
                                        </td>
                                        <td></td>
                                        <td>
                                            ポイント (Credit )利用
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M8.1796 16.7698C8.1596 16.7698 8.12961 16.7698 8.10961 16.7698C7.13961 16.6798 6.22961 16.2299 5.54961 15.5099C3.94961 13.8299 3.94961 11.0999 5.54961 9.41986L7.73961 7.11984C8.51961 6.29984 9.56961 5.83984 10.6896 5.83984C11.8096 5.83984 12.8596 6.28984 13.6396 7.11984C15.2396 8.79984 15.2396 11.5298 13.6396 13.2098L12.5496 14.3598C12.2596 14.6598 11.7896 14.6699 11.4896 14.3899C11.1896 14.0999 11.1796 13.6298 11.4596 13.3298L12.5496 12.1798C13.6096 11.0698 13.6096 9.25985 12.5496 8.15985C11.5596 7.11985 9.81961 7.11985 8.81961 8.15985L6.62961 10.4598C5.56961 11.5698 5.56961 13.3799 6.62961 14.4799C7.05961 14.9399 7.63961 15.2198 8.24961 15.2798C8.65961 15.3198 8.9596 15.6899 8.9196 16.0999C8.8896 16.4799 8.5596 16.7698 8.1796 16.7698Z" fill="#7A28A0"/>
                                                    <path d="M13.3102 18.1599C12.1902 18.1599 11.1402 17.7099 10.3602 16.8799C8.76016 15.1999 8.76016 12.4699 10.3602 10.7899L11.4502 9.63991C11.7402 9.33991 12.2102 9.32988 12.5102 9.60988C12.8102 9.89988 12.8201 10.3699 12.5401 10.6699L11.4502 11.8199C10.3902 12.9299 10.3902 14.7399 11.4502 15.8399C12.4402 16.8799 14.1801 16.8899 15.1801 15.8399L17.3702 13.5399C18.4302 12.4299 18.4302 10.6199 17.3702 9.51989C16.9402 9.05989 16.3602 8.7799 15.7502 8.7199C15.3402 8.6799 15.0402 8.30989 15.0802 7.89989C15.1202 7.48989 15.4801 7.17991 15.9001 7.22991C16.8701 7.32991 17.7802 7.76989 18.4602 8.48989C20.0602 10.1699 20.0602 12.8999 18.4602 14.5799L16.2702 16.8799C15.4802 17.7099 14.4302 18.1599 13.3102 18.1599Z" fill="#7A28A0"/>
                                                    <path d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z" fill="#7A28A0"/>
                                                </svg>
                                                参考文献の品質チェック
                                            </h5>
                                            <span>信頼度の高い文献の引用で論文を強化</span>
                                        </td>
                                        <td>
                                            ポイント (Credit )利用
                                        </td>
                                        <td></td>
                                        <td>
                                            ポイント (Credit )利用
                                        </td>
                                        <td></td>
                                        <td>
                                            ポイント (Credit )利用
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M3.5 18V7C3.5 3 4.5 2 8.5 2H15.5C19.5 2 20.5 3 20.5 7V17C20.5 17.14 20.5 17.28 20.49 17.42" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M6.35 15H20.5V18.5C20.5 20.43 18.93 22 17 22H7C5.07 22 3.5 20.43 3.5 18.5V17.85C3.5 16.28 4.78 15 6.35 15Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                ジャーナルファインダー
                                            </h5>
                                            <span>論文コンセプトと一致したジャーナルの検索</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M16 12L18 14L22 10M8 3H2V18H9C10.7 18 12 19.3 12 21V7C12 4.8 10.2 3 8 3Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M22 6V3H16C13.8 3 12 4.8 12 7V21C12 19.3 13.3 18 15 18H22V15.7" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                出版適正チェック
                                            </h5>
                                            <span>出版実現に向けた包括的な評価</span>
                                        </td>
                                        <td>
                                            ポイント (Credit )利用
                                        </td>
                                        <td></td>
                                        <td>
                                            ポイント (Credit )利用
                                        </td>
                                        <td></td>
                                        <td>
                                            ポイント (Credit )利用
                                        </td>
                                    </tr>

                                    <!-- end AI reports -->

                                    <!-- Start Publication Ready Writing -->
                                    <tr class="noBorder">
                                        <td colspan="5">
                                            <h3 class="middleTitle"><span></span> 出版できる英文のためのチェック</h3>
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8 2V5" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M16 2V5" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M21 8.5V13.63C20.11 12.92 18.98 12.5 17.75 12.5C16.52 12.5 15.37 12.93 14.47 13.66C13.26 14.61 12.5 16.1 12.5 17.75C12.5 18.73 12.78 19.67 13.26 20.45C13.63 21.06 14.11 21.59 14.68 22H8C4.5 22 3 20 3 17V8.5C3 5.5 4.5 3.5 8 3.5H16C19.5 3.5 21 5.5 21 8.5Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M7 11H13" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M7 16H9.62" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M23 17.75C23 18.73 22.72 19.67 22.24 20.45C21.96 20.93 21.61 21.35 21.2 21.69C20.28 22.51 19.08 23 17.75 23C16.6 23 15.54 22.63 14.68 22C14.11 21.59 13.63 21.06 13.26 20.45C12.78 19.67 12.5 18.73 12.5 17.75C12.5 16.1 13.26 14.61 14.47 13.66C15.37 12.93 16.52 12.5 17.75 12.5C18.98 12.5 20.11 12.92 21 13.63C22.22 14.59 23 16.08 23 17.75Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M17.75 20.25C17.75 18.87 18.87 17.75 20.25 17.75C18.87 17.75 17.75 16.63 17.75 15.25C17.75 16.63 16.63 17.75 15.25 17.75C16.63 17.75 17.75 18.87 17.75 20.25Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                ライティングのインパクト強化
                                            </h5>
                                            <span>具体的かつストレートな文章に修正し文章のインパクトを最大化</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M17.62 9.61914H12.37C11.96 9.61914 11.62 9.27914 11.62 8.86914C11.62 8.45914 11.96 8.11914 12.37 8.11914H17.62C18.03 8.11914 18.37 8.45914 18.37 8.86914C18.37 9.27914 18.04 9.61914 17.62 9.61914Z" fill="#7A28A0"/>
                                                    <path d="M7.12006 10.3803C6.93006 10.3803 6.74006 10.3103 6.59006 10.1603L5.84006 9.41031C5.55006 9.12031 5.55006 8.64031 5.84006 8.35031C6.13006 8.06031 6.61006 8.06031 6.90006 8.35031L7.12006 8.57031L8.84006 6.85031C9.13006 6.56031 9.61006 6.56031 9.90006 6.85031C10.1901 7.14031 10.1901 7.62031 9.90006 7.91031L7.65006 10.1603C7.51006 10.3003 7.32006 10.3803 7.12006 10.3803Z" fill="#7A28A0"/>
                                                    <path d="M17.62 16.6191H12.37C11.96 16.6191 11.62 16.2791 11.62 15.8691C11.62 15.4591 11.96 15.1191 12.37 15.1191H17.62C18.03 15.1191 18.37 15.4591 18.37 15.8691C18.37 16.2791 18.04 16.6191 17.62 16.6191Z" fill="#7A28A0"/>
                                                    <path d="M7.12006 17.3803C6.93006 17.3803 6.74006 17.3103 6.59006 17.1603L5.84006 16.4103C5.55006 16.1203 5.55006 15.6403 5.84006 15.3503C6.13006 15.0603 6.61006 15.0603 6.90006 15.3503L7.12006 15.5703L8.84006 13.8503C9.13006 13.5603 9.61006 13.5603 9.90006 13.8503C10.1901 14.1403 10.1901 14.6203 9.90006 14.9103L7.65006 17.1603C7.51006 17.3003 7.32006 17.3803 7.12006 17.3803Z" fill="#7A28A0"/>
                                                    <path d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z" fill="#7A28A0"/>
                                                </svg>
                                                専門的な語句
                                            </h5>
                                            <span>適切な専門用語を提案</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.57606 17.4436C3.26646 17.7676 2.91606 18.0592 2.54766 18.298C2.48149 18.3431 2.40698 18.3745 2.32849 18.3904C2.25001 18.4062 2.16915 18.4062 2.09068 18.3903C2.0122 18.3744 1.9377 18.343 1.87156 18.2978C1.80543 18.2527 1.74899 18.1948 1.70558 18.1275C1.66217 18.0602 1.63267 17.985 1.6188 17.9061C1.60494 17.8272 1.607 17.7464 1.62486 17.6684C1.64273 17.5903 1.67603 17.5166 1.72281 17.4517C1.76959 17.3867 1.8289 17.3317 1.89726 17.29C2.77686 16.7212 3.43806 15.8164 3.58926 15.1432C3.62145 14.9989 3.70581 14.8716 3.82614 14.7856C3.94647 14.6997 4.09429 14.6612 4.24125 14.6776C4.38821 14.6939 4.52395 14.764 4.62243 14.8743C4.72091 14.9846 4.77519 15.1274 4.77486 15.2752V22.1992C4.77486 22.3583 4.71164 22.511 4.59912 22.6235C4.4866 22.736 4.33399 22.7992 4.17486 22.7992C4.01573 22.7992 3.86311 22.736 3.75059 22.6235C3.63807 22.511 3.57486 22.3583 3.57486 22.1992L3.57606 17.4436ZM9.10566 15.8764C8.34966 15.8764 7.79286 16.5268 7.79286 17.164C7.79286 17.3231 7.72964 17.4758 7.61712 17.5883C7.5046 17.7008 7.35199 17.764 7.19286 17.764C7.03373 17.764 6.88111 17.7008 6.76859 17.5883C6.65607 17.4758 6.59286 17.3231 6.59286 17.164C6.59286 15.9136 7.63686 14.6764 9.10566 14.6764C9.97085 14.6764 10.8097 15.0676 11.2801 15.7672C11.7721 16.4992 11.7937 17.4628 11.2117 18.4192C10.9165 18.9052 10.5121 19.2736 10.1125 19.5784C9.91206 19.732 9.70446 19.8748 9.50766 20.0092L9.42366 20.0668C9.25566 20.182 9.09486 20.2912 8.94006 20.4028C8.42406 20.7796 8.05446 21.13 7.89006 21.5992H10.9945C11.1536 21.5992 11.3062 21.6624 11.4187 21.775C11.5312 21.8875 11.5945 22.0401 11.5945 22.1992C11.5945 22.3583 11.5312 22.511 11.4187 22.6235C11.3062 22.736 11.1536 22.7992 10.9945 22.7992H7.19286C7.03373 22.7992 6.88111 22.736 6.76859 22.6235C6.65607 22.511 6.59286 22.3583 6.59286 22.1992C6.59286 20.7988 7.43646 20.0128 8.23446 19.4332C8.40486 19.3084 8.58126 19.1884 8.74926 19.0732L8.83086 19.018C9.02646 18.8848 9.21126 18.7564 9.38285 18.6244C9.73085 18.3604 10.0033 18.0976 10.1869 17.7964C10.5601 17.1808 10.4797 16.7284 10.2841 16.4368C10.0681 16.114 9.63006 15.8764 9.10566 15.8764ZM14.4757 16.1884C14.3162 16.3248 14.1988 16.5038 14.1373 16.7044C14.1159 16.7811 14.0795 16.8527 14.0302 16.9151C13.9809 16.9776 13.9197 17.0296 13.8501 17.0682C13.7805 17.1067 13.704 17.1311 13.6249 17.1398C13.5458 17.1484 13.4658 17.1413 13.3895 17.1188C13.3132 17.0963 13.2421 17.0588 13.1804 17.0086C13.1187 16.9583 13.0676 16.8963 13.0301 16.8262C12.9926 16.756 12.9694 16.6791 12.9619 16.5999C12.9545 16.5207 12.9628 16.4408 12.9865 16.3648C13.1139 15.9414 13.3605 15.5635 13.6969 15.2764C14.1145 14.92 14.7049 14.6764 15.4897 14.6764C17.0797 14.6764 18.0181 15.7996 18.0181 16.8496C18.0181 17.2636 17.9341 17.8972 17.4925 18.4336C17.4145 18.5296 17.3281 18.6184 17.2321 18.7012C17.3821 18.8116 17.5237 18.9472 17.6449 19.1116C17.8849 19.4356 18.0169 19.8388 18.0169 20.3116C18.0169 21.1672 17.7181 21.8236 17.1949 22.2508C16.6909 22.6612 16.0585 22.7992 15.4909 22.7992C14.9509 22.7992 14.4241 22.7128 13.9717 22.4356C13.5061 22.15 13.1893 21.7084 12.9937 21.1336C12.9683 21.059 12.9579 20.9801 12.963 20.9015C12.9681 20.8228 12.9886 20.746 13.0235 20.6753C13.0583 20.6046 13.1067 20.5414 13.1659 20.4894C13.2251 20.4374 13.294 20.3976 13.3687 20.3722C13.4433 20.3468 13.5222 20.3364 13.6008 20.3415C13.6794 20.3467 13.7563 20.3672 13.827 20.402C13.8977 20.4368 13.9609 20.4853 14.0129 20.5445C14.0649 20.6037 14.1047 20.6726 14.1301 20.7472C14.2561 21.1168 14.4217 21.304 14.5981 21.412C14.7889 21.5284 15.0661 21.5992 15.4897 21.5992C15.8857 21.5992 16.2157 21.5008 16.4365 21.3208C16.6357 21.1588 16.8181 20.8708 16.8181 20.3116C16.8271 20.1379 16.7781 19.9661 16.6789 19.8232C16.5791 19.6981 16.449 19.6006 16.3009 19.54C15.9409 19.3768 15.4825 19.3372 15.1681 19.3372C15.0089 19.3372 14.8563 19.274 14.7438 19.1615C14.6313 19.049 14.5681 18.8963 14.5681 18.7372C14.5681 18.5781 14.6313 18.4255 14.7438 18.313C14.8563 18.2004 15.0089 18.1372 15.1681 18.1372C16.0225 18.1372 16.3921 17.8828 16.5661 17.6716C16.7581 17.4388 16.8181 17.128 16.8181 16.8496C16.8181 16.5136 16.4701 15.8764 15.4897 15.8764C14.9677 15.8764 14.6605 16.0324 14.4757 16.1884ZM2.40246 11.0992C2.40246 10.8605 2.49728 10.6316 2.66606 10.4628C2.83484 10.294 3.06376 10.1992 3.30246 10.1992H20.7025C20.9412 10.1992 21.1701 10.294 21.3389 10.4628C21.5076 10.6316 21.6025 10.8605 21.6025 11.0992C21.6025 11.3379 21.5076 11.5668 21.3389 11.7356C21.1701 11.9044 20.9412 11.9992 20.7025 11.9992H3.30246C3.06376 11.9992 2.83484 11.9044 2.66606 11.7356C2.49728 11.5668 2.40246 11.3379 2.40246 11.0992ZM2.40246 5.09922C2.40246 4.86052 2.49728 4.63161 2.66606 4.46282C2.83484 4.29404 3.06376 4.19922 3.30246 4.19922H20.7025C20.9412 4.19922 21.1701 4.29404 21.3389 4.46282C21.5076 4.63161 21.6025 4.86052 21.6025 5.09922C21.6025 5.33791 21.5076 5.56683 21.3389 5.73562C21.1701 5.9044 20.9412 5.99922 20.7025 5.99922H3.30246C3.06376 5.99922 2.83484 5.9044 2.66606 5.73562C2.49728 5.56683 2.40246 5.33791 2.40246 5.09922ZM19.2025 17.0992C19.2025 16.8605 19.2973 16.6316 19.4661 16.4628C19.6348 16.294 19.8638 16.1992 20.1025 16.1992H20.7025C20.9412 16.1992 21.1701 16.294 21.3389 16.4628C21.5076 16.6316 21.6025 16.8605 21.6025 17.0992C21.6025 17.3379 21.5076 17.5668 21.3389 17.7356C21.1701 17.9044 20.9412 17.9992 20.7025 17.9992H20.1025C19.8638 17.9992 19.6348 17.9044 19.4661 17.7356C19.2973 17.5668 19.2025 17.3379 19.2025 17.0992Z" fill="#7A28A0"/>
                                                </svg>
                                                単語数の削減
                                            </h5>
                                            <span>簡潔で力強く、ジャーナルガイドラインに沿った英文作成が簡単に</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.91 17.1794C3.72 17.1794 3.53 17.1095 3.38 16.9595C2.01 15.5795 1.25 13.7595 1.25 11.8295C1.25 7.81946 4.5 4.55944 8.5 4.55944L14.57 4.57945L13.48 3.53942C13.18 3.24942 13.17 2.77942 13.46 2.47942C13.75 2.17942 14.22 2.16946 14.52 2.45946L16.96 4.79943C17.18 5.00943 17.25 5.33943 17.14 5.61943C17.03 5.89943 16.75 6.08946 16.44 6.08946L8.49001 6.06945C5.32001 6.06945 2.74001 8.65946 2.74001 11.8395C2.74001 13.3695 3.33999 14.8194 4.42999 15.9094C4.71999 16.1994 4.71999 16.6794 4.42999 16.9694C4.28999 17.1094 4.1 17.1794 3.91 17.1794Z" fill="#7A28A0"/>
                                                    <path d="M9.9999 21.75C9.8099 21.75 9.6299 21.6799 9.4799 21.5399L7.0399 19.2C6.8199 18.99 6.7499 18.66 6.8599 18.38C6.9699 18.1 7.2499 17.9099 7.5599 17.9099L15.5099 17.93C18.6799 17.93 21.2599 15.3399 21.2599 12.1599C21.2599 10.6299 20.6599 9.18 19.5699 8.09C19.2799 7.8 19.2799 7.32 19.5699 7.03C19.8599 6.74 20.3399 6.74 20.6299 7.03C21.9999 8.41 22.7599 10.2299 22.7599 12.1599C22.7599 16.1699 19.5099 19.43 15.5099 19.43L9.4399 19.4099L10.5299 20.45C10.8299 20.74 10.8399 21.21 10.5499 21.51C10.3899 21.67 10.1999 21.75 9.9999 21.75Z" fill="#7A28A0"/>
                                                    <path d="M15 12.75H9C8.59 12.75 8.25 12.41 8.25 12C8.25 11.59 8.59 11.25 9 11.25H15C15.41 11.25 15.75 11.59 15.75 12C15.75 12.41 15.41 12.75 15 12.75Z" fill="#7A28A0"/>
                                                </svg>
                                                一貫性チェック
                                            </h5>
                                            <span>ダッシュ、スペル、余白、数字の表記など</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.49994 20.4995C4.32994 21.3295 5.66994 21.3295 6.49994 20.4995L19.4999 7.49945C20.3299 6.66945 20.3299 5.32945 19.4999 4.49945C18.6699 3.66945 17.3299 3.66945 16.4999 4.49945L3.49994 17.4995C2.66994 18.3295 2.66994 19.6695 3.49994 20.4995Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M18.01 8.99023L15.01 5.99023" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8.5 2.44L10 2L9.56 3.5L10 5L8.5 4.56L7 5L7.44 3.5L7 2L8.5 2.44Z" stroke="#7A28A0" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M4.5 8.44L6 8L5.56 9.5L6 11L4.5 10.56L3 11L3.44 9.5L3 8L4.5 8.44Z" stroke="#7A28A0" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M19.5 13.44L21 13L20.56 14.5L21 16L19.5 15.56L18 16L18.44 14.5L18 13L19.5 13.44Z" stroke="#7A28A0" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                文書タイプに基づく提案
                                            </h5>
                                            <span>研究論文、臨床試験報告書、記事/ブログなど</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>
                                    <!-- End Publication Ready Writing -->

                                    <!-- Start: Journal Publication Readiness-->
                                    <tr class="noBorder">
                                        <td colspan="5">
                                            <h3 class="middleTitle"><span></span> ジャーナル掲載適正</h3>
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M3.5 18V7C3.5 3 4.5 2 8.5 2H15.5C19.5 2 20.5 3 20.5 7V17C20.5 17.14 20.5 17.28 20.49 17.42" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M6.35 15H20.5V18.5C20.5 20.43 18.93 22 17 22H7C5.07 22 3.5 20.43 3.5 18.5V17.85C3.5 16.28 4.78 15 6.35 15Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                ジャーナルとの適合性チェック
                                            </h5>
                                            <span>原稿がターゲットジャーナルのスコープ (掲載範囲 )に適合するかをチェックし、適合するジャーナルを提案</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M6.04024 7.772C3.58024 8.329 2.35024 8.607 2.05723 9.548C1.76523 10.488 2.60324 11.469 4.28024 13.43L4.71424 13.937C5.19024 14.494 5.42923 14.773 5.53623 15.117C5.64323 15.462 5.60723 15.834 5.53523 16.577L5.46923 17.254C5.21623 19.871 5.08924 21.179 5.85524 21.76C6.62124 22.342 7.77323 21.811 10.0752 20.751L10.6722 20.477C11.3262 20.175 11.6532 20.025 12.0002 20.025C12.3472 20.025 12.6742 20.175 13.3292 20.477L13.9242 20.751C16.2272 21.811 17.3792 22.341 18.1442 21.761C18.9112 21.179 18.7842 19.871 18.5312 17.254M19.7202 13.43C21.3972 11.47 22.2352 10.489 21.9432 9.548C21.6502 8.607 20.4202 8.328 17.9602 7.772L17.3242 7.628C16.6252 7.47 16.2762 7.391 15.9952 7.178C15.7152 6.965 15.5352 6.642 15.1752 5.996L14.8472 5.408C13.5802 3.136 12.9472 2 12.0002 2C11.0532 2 10.4202 3.136 9.15323 5.408" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round"/>
                                                </svg>
                                                キーワード提案
                                            </h5>
                                            <span>原稿のキーワードを提案</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M8 12.1992H15" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8 16.1992H12.38" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M16 4.01953C19.33 4.19953 21 5.42953 21 9.99953V15.9995C21 19.9995 20 21.9995 15 21.9995H9C4 21.9995 3 19.9995 3 15.9995V9.99953C3 5.43953 4.67 4.19953 8 4.01953" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                論文要約
                                            </h5>
                                            <span>原稿がターゲットジャーナルのスコープ (掲載範囲 )に適合するかをチェックし、適合するジャーナルを提案</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M7.79999 21.4698H4.58002C2.75002 21.4698 1.25 19.9798 1.25 18.1398V12.3398C1.25 11.9298 1.59 11.5898 2 11.5898H7.79999C9.69999 11.5898 11.13 13.0198 11.13 14.9198V18.1398C11.12 20.0398 9.68999 21.4698 7.79999 21.4698ZM2.75 13.0998V18.1498C2.75 19.1598 3.57002 19.9798 4.58002 19.9798H7.79999C8.85999 19.9798 9.63 19.2098 9.63 18.1498V14.9298C9.63 13.8698 8.85999 13.0998 7.79999 13.0998H2.75Z" fill="#7A28A0"/>
                                                    <path d="M2 13.1008C1.59 13.1008 1.25 12.7608 1.25 12.3508C1.25 6.10077 2.52002 4.79081 6.15002 2.64081C6.51002 2.43081 6.96999 2.55082 7.17999 2.90082C7.38999 3.26082 7.26998 3.72079 6.91998 3.93079C3.67998 5.85079 2.75 6.65077 2.75 12.3508C2.75 12.7608 2.41 13.1008 2 13.1008Z" fill="#7A28A0"/>
                                                    <path d="M19.4211 21.4698H16.2011C14.3711 21.4698 12.8711 19.9798 12.8711 18.1398V12.3398C12.8711 11.9298 13.2111 11.5898 13.6211 11.5898H19.4211C21.3211 11.5898 22.7511 13.0198 22.7511 14.9198V18.1398C22.7511 20.0398 21.3211 21.4698 19.4211 21.4698ZM14.3811 13.0998V18.1498C14.3811 19.1598 15.2011 19.9798 16.2111 19.9798H19.4311C20.4911 19.9798 21.2611 19.2098 21.2611 18.1498V14.9298C21.2611 13.8698 20.4911 13.0998 19.4311 13.0998H14.3811Z" fill="#7A28A0"/>
                                                    <path d="M13.6289 13.1008C13.2189 13.1008 12.8789 12.7608 12.8789 12.3508C12.8789 6.10077 14.1489 4.79081 17.7789 2.64081C18.1389 2.43081 18.5989 2.55082 18.8089 2.90082C19.0189 3.26082 18.8989 3.72079 18.5489 3.93079C15.3089 5.85079 14.3789 6.65077 14.3789 12.3508C14.3789 12.7608 14.0389 13.1008 13.6289 13.1008Z" fill="#7A28A0"/>
                                                </svg>
                                                倫理チェック
                                            </h5>
                                            <span>必要な申告がすべてなされているかを確認</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M9.31055 14.6992L10.8105 16.1992L14.8105 12.1992" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M16 4.01953C19.33 4.19953 21 5.42953 21 9.99953V15.9995C21 19.9995 20 21.9995 15 21.9995H9C4 21.9995 3 19.9995 3 15.9995V9.99953C3 5.43953 4.67 4.19953 8 4.01953" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                技術的完全性チェック
                                            </h5>
                                            <span>要旨、単語数、セクション見出しなど、標準的な論文の要件をチェック</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>
                                    <!-- End: Journal Publication Readiness-->

                                    <!-- Start Credits-->
                                    <tr class="noBorder">
                                        <td colspan="5">
                                            <h3 class="middleTitle"><span></span> ポイント (Credit )</h3>
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M15.97 18.75C14.3 18.75 12.7 18.13 11.47 17.02C11.31 16.88 11.22 16.67 11.22 16.46C11.22 16.25 11.31 16.04 11.47 15.9C12.58 14.92 13.22 13.5 13.22 12C13.22 10.5 12.58 9.08 11.47 8.1C11.31 7.96 11.22 7.76 11.22 7.54C11.22 7.33 11.31 7.12 11.47 6.98C12.71 5.86 14.3 5.25 15.97 5.25C19.69 5.25 22.72 8.28 22.72 12C22.72 15.72 19.7 18.75 15.97 18.75ZM13.1 16.39C13.95 16.95 14.94 17.25 15.98 17.25C18.87 17.25 21.23 14.89 21.23 12C21.23 9.11 18.87 6.75 15.98 6.75C14.95 6.75 13.95 7.05 13.1 7.61C14.14 8.82 14.73 10.37 14.73 12C14.73 13.63 14.14 15.18 13.1 16.39Z" fill="#7A28A0"/>
                                                    <path d="M7.96997 18.75C4.24997 18.75 1.21997 15.72 1.21997 12C1.21997 8.28 4.24997 5.25 7.96997 5.25C9.63997 5.25 11.24 5.87 12.47 6.98C13.89 8.24 14.72 10.07 14.72 12C14.72 13.93 13.9 15.75 12.47 17.02C11.24 18.13 9.63997 18.75 7.96997 18.75ZM7.96997 6.75C5.07997 6.75 2.71997 9.11 2.71997 12C2.71997 14.89 5.07997 17.25 7.96997 17.25C9.26997 17.25 10.51 16.77 11.47 15.9C12.59 14.91 13.22 13.49 13.22 12C13.22 10.51 12.58 9.08 11.47 8.1C10.51 7.23 9.26997 6.75 7.96997 6.75Z" fill="#7A28A0"/>
                                                </svg>
                                                毎月付与されるポイント (Credit )
                                            </h5>
                                            <span>各種機能にご利用いただけるポイント (Credit )を毎月付与</span>
                                        </td>
                                        <td>
                                            4
                                        </td>
                                        <td></td>
                                        <td>
                                            10
                                        </td>
                                        <td></td>
                                        <td>
                                            10
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M8.67188 14.3298C8.67188 15.6198 9.66188 16.6598 10.8919 16.6598H13.4019C14.4719 16.6598 15.3419 15.7498 15.3419 14.6298C15.3419 13.4098 14.8119 12.9798 14.0219 12.6998L9.99187 11.2998C9.20187 11.0198 8.67188 10.5898 8.67188 9.36984C8.67188 8.24984 9.54187 7.33984 10.6119 7.33984H13.1219C14.3519 7.33984 15.3419 8.37984 15.3419 9.66984" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M12 6V18" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H15C20 2 22 4 22 9V15C22 20 20 22 15 22Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                追加ポイント (Credit )の購入
                                            </h5>
                                            <span>必要に応じ有効期限なしのポイント (Credit )の購入も可能</span>
                                        </td>
                                        <td>
                                            ポイント (Credit )の追加購入時<br>割引なし
                                        </td>
                                        <td></td>
                                        <td>
                                            ポイント (Credit )の追加購入時<br>最大40％割引
                                        </td>
                                        <td></td>
                                        <td>
                                            ポイント (Credit )の追加購入時<br>
                                            最大40％割引
                                        </td>
                                    </tr>
                                    <!-- Ends Credits-->


                                    <!-- STart Access to other Enago AI products -->
                                    <tr class="noBorder">
                                        <td colspan="5">
                                            <h3 class="middleTitle"><span></span> 他のエナゴAI製品へのアクセス</h3>
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M17 13.4V16.4C17 20.4 15.4 22 11.4 22H7.6C3.6 22 2 20.4 2 16.4V12.6C2 8.6 3.6 7 7.6 7H10.6" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M17 13.4H13.8C11.4 13.4 10.6 12.6 10.6 10.2V7L17 13.4Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M11.6 2H15.6" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M7 5C7 3.34 8.34 2 10 2H12.62" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M21.9999 8V14.19C21.9999 15.74 20.7399 17 19.1899 17" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M22 8H19C16.75 8 16 7.25 16 5V2L22 8Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                Enago Reports
                                            </h5>
                                            <span>TrinkaアカウントとTrinkaポイント (Credit )を使用した、Enago Reportsのご利用</span>
                                        </td>
                                        <td>月4ポイント (Credit )<br/>で利用可能</td>
                                        <td></td>
                                        <td>月10ポイント (Credit )<br/>で利用可能</td>
                                        <td></td>
                                        <td>月10ポイント (Credit )<br/>で利用可能</td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M22 16.7397V4.6697C22 3.4697 21.02 2.5797 19.83 2.6797H19.77C17.67 2.8597 14.48 3.9297 12.7 5.0497L12.53 5.1597C12.24 5.3397 11.76 5.3397 11.47 5.1597L11.22 5.0097C9.44 3.8997 6.26 2.8397 4.16 2.6697C2.97 2.5697 2 3.4697 2 4.6597V16.7397C2 17.6997 2.78 18.5997 3.74 18.7197L4.03 18.7597C6.2 19.0497 9.55 20.1497 11.47 21.1997L11.51 21.2197C11.78 21.3697 12.21 21.3697 12.47 21.2197C14.39 20.1597 17.75 19.0497 19.93 18.7597L20.26 18.7197C21.22 18.5997 22 17.6997 22 16.7397Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M12 5.49023V20.4902" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M7.75 8.49023H5.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8.5 11.4902H5.5" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                Enago Read
                                            </h5>
                                            <span>エナゴまたはTrinkaのアカウントログインで利用可能</span>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>
                                    <!-- End Access to other Enago AI products -->

                                    <!-- Start Data and Security -->
                                    <tr class="noBorder">
                                        <td colspan="5">
                                            <h3 class="middleTitle"><span></span> データとセキュリティ</h3>
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12 2V8L14 6" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M12 8L10 6" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M7 12C3 12 3 13.79 3 16V17C3 19.76 3 22 8 22H16C20 22 21 19.76 21 17V16C21 13.79 21 12 17 12C16 12 15.72 12.21 15.2 12.6L14.18 13.68C13 14.94 11 14.94 9.81 13.68L8.8 12.6C8.28 12.21 8 12 7 12Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M5 11.9991V7.99906C5 5.98906 5 4.32906 8 4.03906" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M19 11.9991V7.99906C19 5.98906 19 4.32906 16 4.03906" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                ファイルの保存
                                            </h5>
                                            <span>Trinkaに保存できるファイル数は無制限</span>
                                        </td>
                                        <td>
                                            無制限
                                        </td>
                                        <td></td>
                                        <td>
                                            無制限
                                        </td>
                                        <td></td>
                                        <td>
                                            無制限
                                        </td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M10.49 2.23055L5.50003 4.11055C4.35003 4.54055 3.41003 5.90055 3.41003 7.12055V14.5505C3.41003 15.7305 4.19003 17.2805 5.14003 17.9905L9.44003 21.2005C10.85 22.2605 13.17 22.2605 14.58 21.2005L18.88 17.9905C19.83 17.2805 20.61 15.7305 20.61 14.5505V7.12055C20.61 5.89055 19.67 4.53055 18.52 4.10055L13.53 2.23055C12.68 1.92055 11.32 1.92055 10.49 2.23055Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M9.05005 11.8697L10.66 13.4797L14.96 9.17969" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                標準セキュリティ
                                            </h5>
                                            <span>256ビットの公開鍵/暗号鍵によるデータおよびファイル転送の暗号化</span>
                                        </td>
                                        <td>
                                            256ビットAES
                                        </td>
                                        <td></td>
                                        <td>
                                            256ビットAES
                                        </td>
                                        <td></td>
                                        <td>
                                            256ビットAES
                                        </td>
                                    </tr>
                                    <!-- <tr>
                                        <td style="border-bottom: none;"></td>
                                        <td style="border-bottom: none;"></td>
                                        <td style="border-bottom: none;"></td>
                                        <td style="border-bottom: none;"></td>
                                    </tr> -->
                                    <!-- End Data and Security -->

                                    <!-- Start Personal-->
                                    <tr class="noBorder">
                                        <td colspan="5">
                                            <h3 class="middleTitle"><span></span> パーソナライズ機能</h3>
                                        </td>
                                        <td></td>
                                    </tr>

                                    <tr>
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M3.5 18V7C3.5 3 4.5 2 8.5 2H15.5C19.5 2 20.5 3 20.5 7V17C20.5 17.14 20.5 17.28 20.49 17.42" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M6.35 15H20.5V18.5C20.5 20.43 18.93 22 17 22H7C5.07 22 3.5 20.43 3.5 18.5V17.85C3.5 16.28 4.78 15 6.35 15Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8 7H16" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8 10.5H13" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                マイ・ディクショナリー
                                            </h5>
                                        </td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                        <td></td>
                                        <td>
                                            <img src="../../../assets/images/tick-circle.svg" alt="check">
                                        </td>
                                    </tr>

                                    <tr class="personalizationRow">
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M18.334 5.41602H13.334" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M4.99935 5.41602H1.66602" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M8.33268 8.33333C9.94351 8.33333 11.2493 7.0275 11.2493 5.41667C11.2493 3.80584 9.94351 2.5 8.33268 2.5C6.72185 2.5 5.41602 3.80584 5.41602 5.41667C5.41602 7.0275 6.72185 8.33333 8.33268 8.33333Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M18.3333 14.584H15" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M6.66602 14.584H1.66602" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M11.6667 17.4993C13.2775 17.4993 14.5833 16.1935 14.5833 14.5827C14.5833 12.9719 13.2775 11.666 11.6667 11.666C10.0558 11.666 8.75 12.9719 8.75 14.5827C8.75 16.1935 10.0558 17.4993 11.6667 17.4993Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                スタイルガイドのカスタマイズ
                                            </h5>
                                        </td>
                                        <td rowspan="6">
                                           AES 256暗号化
                                        </td>
                                        <td rowspan="6" colspan="3">
                                           AES 256暗号化
                                        </td>
                                        <td rowspan="6" class="purple-bg">
                                           AES 256暗号化
                                        </td>
                                    </tr>

                                    <tr class="personalizationRow">
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M5 20C4.45 20 3.979 19.804 3.587 19.412C3.195 19.02 2.99934 18.5493 3 18V4C3 3.45 3.196 2.979 3.588 2.587C3.98 2.195 4.45067 1.99934 5 2H19C19.55 2 20.021 2.196 20.413 2.588C20.805 2.98 21.0007 3.45067 21 4V9.65C20.6833 9.5 20.3583 9.379 20.025 9.287C19.6917 9.195 19.35 9.12434 19 9.075V4H5V13H8.55C8.75 13 8.925 13.046 9.075 13.138C9.225 13.23 9.34167 13.3507 9.425 13.5C9.65834 13.8833 9.91667 14.1833 10.2 14.4C10.4833 14.6167 10.7917 14.775 11.125 14.875C11.075 15.2083 11.0417 15.5457 11.025 15.887C11.0083 16.2283 11.025 16.566 11.075 16.9C10.475 16.7833 9.91267 16.5623 9.388 16.237C8.86333 15.9117 8.40067 15.4993 8 15H5V18H11.325C11.4417 18.3667 11.575 18.7167 11.725 19.05C11.875 19.3833 12.0583 19.7 12.275 20H5ZM16.725 19.5C16.525 19.4167 16.3373 19.329 16.162 19.237C15.9867 19.145 15.8077 19.0327 15.625 18.9L14.55 19.225C14.4333 19.2583 14.325 19.254 14.225 19.212C14.125 19.17 14.0417 19.0993 13.975 19L13.375 18C13.3083 17.9 13.2917 17.7917 13.325 17.675C13.3583 17.5583 13.4167 17.4583 13.5 17.375L14.325 16.65C14.2917 16.45 14.275 16.2333 14.275 16C14.275 15.7667 14.2917 15.55 14.325 15.35L13.5 14.625C13.4167 14.5417 13.3583 14.4417 13.325 14.325C13.2917 14.2083 13.3083 14.1 13.375 14L13.975 13C14.0417 12.9 14.125 12.8293 14.225 12.788C14.325 12.7467 14.4333 12.7423 14.55 12.775L15.625 13.1C15.8083 12.9667 15.9873 12.8543 16.162 12.763C16.3367 12.6717 16.5243 12.584 16.725 12.5L16.95 11.4C16.9833 11.2833 17.0377 11.1873 17.113 11.112C17.1883 11.0367 17.2923 10.9993 17.425 11H18.625C18.7583 11 18.8627 11.0377 18.938 11.113C19.0133 11.1883 19.0673 11.284 19.1 11.4L19.325 12.5C19.525 12.5833 19.7127 12.671 19.888 12.763C20.0633 12.855 20.2423 12.9673 20.425 13.1L21.5 12.775C21.6167 12.7417 21.725 12.746 21.825 12.788C21.925 12.83 22.0083 12.9007 22.075 13L22.675 14C22.7417 14.1 22.7583 14.2083 22.725 14.325C22.6917 14.4417 22.6333 14.5417 22.55 14.625L21.725 15.35C21.7583 15.55 21.775 15.7667 21.775 16C21.775 16.2333 21.7583 16.45 21.725 16.65L22.55 17.375C22.6333 17.4583 22.6917 17.5583 22.725 17.675C22.7583 17.7917 22.7417 17.9 22.675 18L22.075 19C22.0083 19.1 21.925 19.171 21.825 19.213C21.725 19.255 21.6167 19.259 21.5 19.225L20.425 18.9C20.2417 19.0333 20.0627 19.146 19.888 19.238C19.7133 19.33 19.5257 19.4173 19.325 19.5L19.1 20.6C19.0667 20.7167 19.0123 20.8127 18.937 20.888C18.8617 20.9633 18.7577 21.0007 18.625 21H17.425C17.2917 21 17.1873 20.9623 17.112 20.887C17.0367 20.8117 16.9827 20.716 16.95 20.6L16.725 19.5ZM18.025 18C18.575 18 19.046 17.804 19.438 17.412C19.83 17.02 20.0257 16.5493 20.025 16C20.025 15.45 19.8293 14.979 19.438 14.587C19.0467 14.195 18.5757 13.9993 18.025 14C17.475 14 17.0043 14.196 16.613 14.588C16.2217 14.98 16.0253 15.4507 16.024 16C16.024 16.55 16.22 17.021 16.612 17.413C17.004 17.805 17.4757 18.0007 18.025 18Z" fill="#7A28A0"/>
                                                </svg>
                                                文法ルールのカスタマイズ
                                            </h5>
                                        </td>
                                    </tr>

                                    <tr class="personalizationRow">
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M6.66667 8.33398L5 10.0007L6.66667 11.6673" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M13.334 8.33398L15.0007 10.0007L13.334 11.6673" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M9.99935 18.3327C14.6017 18.3327 18.3327 14.6017 18.3327 9.99935C18.3327 5.39698 14.6017 1.66602 9.99935 1.66602C5.39698 1.66602 1.66602 5.39698 1.66602 9.99935C1.66602 14.6017 5.39698 18.3327 9.99935 18.3327Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10.8327 8.05859L9.16602 11.942" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                自社製品・システムへの統合
                                            </h5>
                                        </td>
                                    </tr>

                                    <tr class="personalizationRow">
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M22 11V17C22 21 21 22 17 22H7C3 22 2 21 2 17V7C2 3 3 2 7 2H8.5C10 2 10.33 2.44 10.9 3.2L12.4 5.2C12.78 5.7 13 6 14 6H17C21 6 22 7 22 11Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10"/>
                                                    <path d="M9.43359 11.8666V11.15C9.43359 9.96031 9.79192 9 11.5835 9C13.3752 9 13.7335 9.96031 13.7335 11.15V11.8666" stroke="#7A28A0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M11.5823 14.4459C11.8198 14.4459 12.0123 14.2534 12.0123 14.0159C12.0123 13.7785 11.8198 13.5859 11.5823 13.5859C11.3448 13.5859 11.1523 13.7785 11.1523 14.0159C11.1523 14.2534 11.3448 14.4459 11.5823 14.4459Z" stroke="#7A28A0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M13.3749 16.1671H9.79163C8.35833 16.1671 8 15.8088 8 14.3755V13.6588C8 12.2255 8.35833 11.8672 9.79163 11.8672H13.3749C14.8082 11.8672 15.1665 12.2255 15.1665 13.6588V14.3755C15.1665 15.8088 14.8082 16.1671 13.3749 16.1671Z" stroke="#7A28A0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                ファイル毎のアクセス設定
                                            </h5>
                                        </td>
                                    </tr>

                                    <tr class="personalizationRow">
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M17.5674 7.14938V12.8493C17.5674 13.7827 17.0674 14.6494 16.2591 15.1244L11.3091 17.9827C10.5008 18.4494 9.50078 18.4494 8.68412 17.9827L3.73411 15.1244C2.92578 14.6577 2.42578 13.791 2.42578 12.8493V7.14938C2.42578 6.21604 2.92578 5.34934 3.73411 4.87434L8.68412 2.01602C9.49245 1.54935 10.4924 1.54935 11.3091 2.01602L16.2591 4.87434C17.0674 5.34934 17.5674 6.20771 17.5674 7.14938Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10.0003 9.16651C11.0726 9.16651 11.9419 8.29719 11.9419 7.22483C11.9419 6.15248 11.0726 5.2832 10.0003 5.2832C8.92791 5.2832 8.05859 6.15248 8.05859 7.22483C8.05859 8.29719 8.92791 9.16651 10.0003 9.16651Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M13.3327 13.8826C13.3327 12.3826 11.841 11.166 9.99935 11.166C8.15768 11.166 6.66602 12.3826 6.66602 13.8826" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                ユーザー管理
                                            </h5>
                                        </td>
                                    </tr>

                                    <tr class="personalizationRow">
                                        <td>
                                            <h5>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M8.42589 9.29102H6.21756C5.69256 9.29102 5.26758 9.71598 5.26758 10.241V14.5076H8.42589V9.29102V9.29102Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M10.6346 5.5H9.36796C8.84296 5.5 8.41797 5.92501 8.41797 6.45001V14.5H11.5763V6.45001C11.5763 5.92501 11.1596 5.5 10.6346 5.5Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M13.7904 10.709H11.582V14.5007H14.7404V11.659C14.732 11.134 14.307 10.709 13.7904 10.709Z" stroke="#7A28A0" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M7.49935 18.3327H12.4993C16.666 18.3327 18.3327 16.666 18.3327 12.4993V7.49935C18.3327 3.33268 16.666 1.66602 12.4993 1.66602H7.49935C3.33268 1.66602 1.66602 3.33268 1.66602 7.49935V12.4993C1.66602 16.666 3.33268 18.3327 7.49935 18.3327Z" stroke="#7A28A0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                                チーム使用状況の監視と分析
                                            </h5>
                                        </td>
                                    </tr>
                                    <!-- End Personal -->
                                </tbody>
                            </table>
                        </div>
                        <em class="d-block mt-4" style="font-size:14px">
                            * 無制限アクセスには<a href="https://www.trinka.ai/termsofservices" class="text-link" target="_blank">Fair Use Policy（公正使用ポリシー）</a>が適用されます。
                        </em>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <div class="pricingTableContentsTwo" style="display: none;" #target>
        <table class="table">
            <thead>
                <tr>
                    <th class="sticky-header">プランの比較</th>
                    <th class="sticky-header">
                        ベーシック
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" target="_blank" class="getStartedButton">今すぐ始める</a>
                    </th>
                    <th class="sticky-header">
                        プレミアム
                        <a href="https://payments.trinka.ai/user/JTdCJTIyZnJta3RnJTIyJTNBdHJ1ZSU3RA?_ga=2.43028453.1701517523.1652768321-1210922333.1648018336" target="_blank" class="PremiumButtons">購入する</a>
                    </th>
                </tr>
            </thead>
            <tr>
                <td colspan="3" class="tableSubHeader">機能</td>
            </tr>
            <tr>
                <td>
                    <p>英文チェック
                        <span class="pricingTableTooltip pricingboxTooltip" alt="句読点、構文、スペル、時制などを含む高度な文法チェックで、ライティングの精度を高められます。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    1か月5000単語まで
                </td>
                <td>
                    ご利用単語数の制限なし*
                </td>
            </tr>

            <tr>
                <td>
                    <p>ファイル自動校正
                        <span class="pricingTableTooltip pricingboxTooltip" alt="WordファイルをTrinkaが数分で自動校正。変更履歴付きのファイルをダウンロードできます。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td rowspan="3">
                    ポイント（Credit）利用で
                    <br>1か月合わせて4回まで
                </td>
                <td rowspan="3">
                    ポイント（Credit）利用で
                    <br>1か月合わせて10回まで
                    <span class="pricingTableTooltip pricingboxTooltip" alt="各プランに付与される無料ポイント（ベーシック2／プレミアム5）を、ファイル自動校正と出版適正チェックにご利用いただけます。">
                        <img src="../../../assets/images/info.svg" alt="icon">
                    </span>
                </td>
            </tr>
            <tr>
                <td style="background: transparent;box-shadow: none;">
                    <p>出版適正チェック
                        <span class="pricingTableTooltip pricingboxTooltip" alt="投稿先ジャーナル候補の提案や、倫理面・コンプライアンスのチェックなど20以上のチェックポイントで文章を査定し、論文受理の可能性を高めます。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
            </tr>
            <tr>
                <td style="background: transparent;box-shadow: none;">
                    <p>引用チェック
                        <span class="pricingTableTooltip pricingboxTooltip" alt="研究の前提や論拠を弱めかねない引用を識別し、論文に信頼性の高い文献を引用できるようにします。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
            </tr>
            <!-- <tr>
                <td>
                    <p>パワーモード
                        <span class="pricingTableTooltip pricingboxTooltip" alt="最先端のAIにより、通常モードより最大40%多くの文法や文脈に基づく改善案を提示。プレミアムプランのファイル自動校正でご利用可能。近日中にTrinka Cloud、Wordアドイン、ブラウザプラグインでもご利用いただけます。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    60 min trial
                </td>
                <td>
                    Complete access
                </td>
            </tr> -->
            <tr>
                <td>
                    <p>盗用・剽窃チェック
                        <span class="pricingTableTooltip pricingboxTooltip" alt="iThenticateが誇る最先端のテキスト類似性検出アルゴリズムと、最大級の有料出版物データベースによる高品質の盗用・剽窃チェック">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td class="single-line-tootltip">
                    毎月1回　盗用・剽窃チェックが無料 <span class="pricingTableTooltip pricingboxTooltip" alt="ポイントのご利用で完全な盗用・剽窃チェックレポートを生成します。">
                        <img src="../../../assets/images/info.svg" alt="icon"></span>
                </td>
                <td class="single-line-tootltip">
                    毎月2回　盗用・剽窃スコアが無料 <span class="pricingTableTooltip pricingboxTooltip" alt="ポイントのご利用で完全な盗用・剽窃チェックレポートを生成します。">
                        <img src="../../../assets/images/info.svg" alt="icon">
                    </span>
                </td>
            </tr>
            <tr>
                <td>
                    <p>校正者による英文校正
                        <span class="pricingTableTooltip pricingboxTooltip" alt="原稿を、エナゴの専門校正者による英文校正サービスに簡単にお送りいただけます。研究分野の専門家が、文章の構造、論文の構成、論旨の流れに踏み込んで校正を行います。またジャーナルの投稿規程に沿ったフォーマット調整も行います。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    お申し込み後すぐにご利用可
                </td>
                <td>
                    お申し込み後すぐにご利用可
                </td>
            </tr>
            <tr>
                <td colspan="3" class="tableSubHeader">連携機能</td>
            </tr>
            <tr>
                <td>
                    <p>Trinka Cloud</p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>
            <tr>
                <td>
                    <p>Wordプラグイン
                        <img src="../../../assets/images/wordAdd_in.svg" alt="word" style="width: 26px;margin-left: 10px; margin-right: 10px;">
                    </p>
                </td>
                <td>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
                        viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
                        <g>
                            <g>
                                <g>
                                    <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717    L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859    c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287    l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285    L284.286,256.002z"
                                        data-original="#000000" class="active-path" data-old_color="#000000" fill="#B72907" />
                                </g>
                            </g>
                        </g>
                    </svg>
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                        id="Capa_1" x="0px" y="0px" viewBox="0 0 512.001 512.001"
                        style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717    L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859    c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287    l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285    L284.286,256.002z"
                                        data-original="#000000" class="active-path" data-old_color="#000000"
                                        fill="#B72907" />
                                </g>
                            </g>
                        </g>
                    </svg> -->
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                    <!-- <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                        style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg> -->
                </td>
            </tr>
            <tr>
                <td>
                    <p>ブラウザプラグイン
                        <b>
                            <img src="../../../assets/images/NewChromeIcon.svg" alt="chrome" style="width: 26px;margin-left: 10px; margin-right: 10px;">
                            <img src="../../../assets/images/NewFirefoxIcon.svg" alt="firefox" style="width: 26px; margin-right: 10px;">
                            <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="edge" style="width: 24px; margin-right: 10px;">
                        </b>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>
            <tr>
                <td>
                    <p>新機能の先行利用</p>
                </td>
                <td>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
                        viewBox="0 0 512.001 512.001" style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
                        <g>
                            <g>
                                <g>
                                    <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717    L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859    c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287    l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285    L284.286,256.002z"
                                        data-original="#000000" class="active-path" data-old_color="#000000" fill="#B72907" />
                                </g>
                            </g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>
            <tr>
                <td>
                    <p>変更履歴付きファイルのダウンロード</p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>
            <tr>
                <td colspan="3" class="tableSubHeader">文法・英文</td>
            </tr>
            <tr>
                <td>
                    <p>高度な文法修正
                        <span class="pricingTableTooltip pricingboxTooltip smallTooltip" alt="複雑な文法ミスや構文、句読点の修正を行います。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>文脈に即したスペルチェック
                        <span class="pricingTableTooltip pricingboxTooltip" alt="分野で使われる専門用語を含め、文脈に合ったスペルへの修正を行います。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>語法、文体修正
                        <span class="pricingTableTooltip pricingboxTooltip smallTooltip" alt="フォーマルな文体へ修正します。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>構文修正
                        <span class="pricingTableTooltip pricingboxTooltip" alt="原稿の分野やジャンルに従った文の組み立てに修正します。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>専門用語の選択
                        <span class="pricingTableTooltip pricingboxTooltip" alt="内容に配慮した最適な単語へ置き換えます。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>専門分野に合わせた校正
                        <span class="pricingTableTooltip pricingboxTooltip" alt="医学、ライフサイエンス、物理学、工学、社会学など、分野を考慮した英文校正を行います。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>スタイルガイドへの準拠
                        <span class="pricingTableTooltip pricingboxTooltip" alt="APA (7th ed)、 AMA (11th ed)、 AGU (2017 ed)、IEEEをはじめとしたスタイルガイドに即したライティングを提案します。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>
            <tr>
                <td colspan="3" class="tableSubHeader">出版に適したライティング</td>
            </tr>

            <tr>
                <td>
                    <p>適切な言葉遣い
                        <span class="pricingTableTooltip pricingboxTooltip" alt="多様性に配慮したインクルーシブな言葉遣いへ修正します。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>明確で伝わりやすい表現
                        <span class="pricingTableTooltip pricingboxTooltip" alt="効果的な情報発信が可能な、具体的で明確な表現を提案します。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>適正な専門用語
                        <span class="pricingTableTooltip pricingboxTooltip" alt="分野で使われる正しい専門用語を提案します。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>単語数削減
                        <span class="pricingTableTooltip pricingboxTooltip" alt="ジャーナルの投稿規程に合わせて単語数を削減し、冗長な表現を簡潔にします。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>用語・表記統一
                        <span class="pricingTableTooltip pricingboxTooltip" alt="ダッシュ、スペース、スペル、数量などの表記を統一します。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>文書の種類に合った修正案
                        <span class="pricingTableTooltip pricingboxTooltip" alt="論文、治験に関わる文書、ブログなど、文書の用途に応じた提案を行います。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td colspan="3" class="tableSubHeader">出版適正チェック</td>
            </tr>

            <tr>
                <td>
                    <p>投稿先ジャーナルとの適合性
                        <span class="pricingTableTooltip pricingboxTooltip" alt="原稿が投稿先ジャーナルのスコープと内容面で適合するかのチェック、および他の投稿先候補の提案を行います。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>キーワード提案
                        <span class="pricingTableTooltip pricingboxTooltip" alt="論文の要点やトピックを抽出し、キーワード候補を提案します。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>要約生成
                        <span class="pricingTableTooltip pricingboxTooltip" alt="論文の構成要素ごとにサマリー（要約）を自動生成します。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>コンプライアンスの確認
                        <span class="pricingTableTooltip pricingboxTooltip" alt="倫理面で求められる記述がなされているかを確認します。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>

            <tr>
                <td>
                    <p>学術論文としての体裁チェック
                        <span class="pricingTableTooltip pricingboxTooltip" alt="要旨、単語数、見出しなど、学術論文の体裁を成しているかをチェックします。">
                            <img src="../../../assets/images/info.svg" alt="icon">
                        </span>
                    </p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>
            <tr>
                <td colspan="3" class="tableSubHeader">データとセキュリティ</td>
            </tr>
            <tr>
                <td>
                    <p>ストレージ</p>
                </td>
                <td>
                    無制限
                </td>
                <td>
                    無制限
                </td>
            </tr>

            <tr>
                <td>
                    <p>堅牢なセキュリティ体制</p>
                </td>
                <td>256ビットAES </td>
                <td>256ビットAES </td>
            </tr>

            <!-- <tr>
                <td>
                    <p>匿名化した上でのAIによるデータ学習</p>
                </td>
                <td><svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                        style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg></td>
                <td><svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512"
                        style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg></td>
            </tr>
            <tr>
                <td>
                    <p>AIによるデータ保存の制御</p>
                </td>
                <td><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                        id="Capa_1" x="0px" y="0px" viewBox="0 0 512.001 512.001"
                        style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717    L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859    c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287    l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285    L284.286,256.002z"
                                        data-original="#000000" class="active-path" data-old_color="#000000"
                                        fill="#B72907" />
                                </g>
                            </g>
                        </g>
                    </svg></td>
                <td>
                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg><svg xmlns=
                    "http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                        id="Capa_1" x="0px" y="0px" viewBox="0 0 512.001 512.001"
                        style="enable-background:new 0 0 512.001 512.001;" xml:space="preserve">
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717    L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859    c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287    l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285    L284.286,256.002z"
                                        data-original="#000000" class="active-path" data-old_color="#000000"
                                        fill="#B72907" />
                                </g>
                            </g>
                        </g>
                    </svg></td>
            </tr>

            <tr>
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>

                <td>
                    <p>ユーザーによるファイル削除</p>
                </td>
                <td>不可<br />（アーカイブフォルダーに移動）</td>
                <td>不可<br />（アーカイブフォルダーに移動）</td>
            </tr> -->

            <tr>
                <td colspan="3" class="tableSubHeader">パーソナライズ機能</td>
            </tr>
            <tr>
                <td>
                    <p>マイ・ディクショナリー</p>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
                <td>
                    <svg class="checkMarkIcon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                        <g>
                            <g>
                                <path d="M256,0C115.03,0,0,115.05,0,256c0,140.97,115.05,256,256,256c140.97,0,256-115.05,256-256C512,115.03,396.95,0,256,0z
			 M256,482C131.383,482,30,380.617,30,256S131.383,30,256,30s226,101.383,226,226S380.617,482,256,482z" />
                            </g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                        <g>
                        </g>
                    </svg>
                </td>
            </tr>
            <tr>
                <td>
                    <p>スタイルガイドのカスタマイズ</p>
                </td>
                <td rowspan="6">
                    <span class="OpenSansFonts">Trinka Enterprise</span>だけの機能</td>
                <td rowspan="6">
                    <span class="OpenSansFonts">Trinka Enterprise</span>だけの機能</td>
            </tr>
            <tr>
                <td style="background: transparent;box-shadow: none;">
                    <p>文法ルールのカスタマイズ</p>
                </td>
            </tr>
            <tr>
                <td style="background: transparent;box-shadow: none;">
                    <p>自社製品・システムへの統合</p>
                </td>
            </tr>
            <tr>
                <td style="background: transparent;box-shadow: none;">
                    <p>ファイル毎のアクセス設定</p>
                </td>
            </tr>
            <tr>
                <td style="background: transparent;box-shadow: none;">
                    <p>ユーザー管理</p>
                </td>
            </tr>
            <tr>
                <td style="background: transparent;box-shadow: none;">
                    <p>使用状況のモニタリングと分析</p>
                </td>
            </tr>

        </table>
    </div>
    <!-- <div class="usagePolicySection">
        <a [routerLink]="['/termsofservices']">*Fair Usage Policy applies.</a>
    </div> -->

    <div class="faqQuestionAnwser section-pd pt-0" #target>
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-10">
                    <div class="trinka-title text-center">
                        <h2>よくあるご質問
                        </h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="faqQuestionsList">
                <div class="accordion" id="faq">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionOne">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                            ベーシックプランとプレミアムプランの違いは何ですか？</a>
                                    </div>
    
                                    <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                        <div class="card-body">
                                            <p style="margin-bottom: 15px;">
                                                Trinkaのプレミアムプランは、ウェブアプリケーション（クラウド）、Wordプラグイン、ブラウザ拡張機能など、すべてのプラットフォームで途切れることなく英文チェックができるのに対し、無料のTrinkaベーシックプランでは月当たり5千語の単語数制限や追加アプリケーションへのアクセス制限があります。
                                            </p>
                                            <p style="margin-bottom: 15px;">プレミアムプランでは、Trinkaの各種機能の利用にご使用いただけるポイントを毎月10ポイント無料で付与、ベーシックプランでは4ポイントのみが付与されます。ポイントは、盗用・剽窃チェック、自動ファイル校正、出版適正チェックに使用することができます。</p>
                                            <p>また、プレミアムプランでは毎月4回まで盗用・剽窃スコアチェックを無料でご使用いただけるのに対し、ベーシックプランでは毎月1回までです。さらにポイントのまとめ購入（ポイント・パックのご購入）の際には、プレミアムプランのユーザーのみに最大40%の割引きが適用されます。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionTwo">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                            aria-controls="QuestionTwoContent">ベーシックプランに利用期限はありますか？</a>
                                    </div>
    
                                    <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                        <div class="card-body">
                                            <p>いいえ。ベーシックプランに利用期限はありませんが、1か月あたりご利用いただける単語数に5000単語までの限りがあります。単語数無制限でご利用いただくには、プレミアムプランへのアップグレードが必要です。
                                            </p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionThree">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                            aria-controls="QuestionThreeContent">
                                            1か月に英文校正が必要な単語数がまだわかりません。
                                        </a>
                                    </div>
    
                                    <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                        <div class="card-body">
                                            <p>まずは無料のベーシックプランで始めてみてください。単語数の上限に達した時点で、お客様のTrinkaのダッシュボードに表示されるポップアップを通じて、プレミアムプランへのアップグレードをご案内します。
                                            </p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionFour">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                            aria-controls="QuestionFourContent">
                                            アカウント作成にクレジットカードの登録は必要ですか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                        <div class="card-body">
                                            <p>Trinkaへのご登録やベーシックプランのご利用には、クレジットカードのご登録は必要ありません。</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionFive">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFiveContent" aria-expanded="true"
                                            aria-controls="QuestionFiveContent">
                                            ベーシックプランでの利用単語数は、どのようにカウントされますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                        <div class="card-body">
                                            <p>利用単語数は、Trinkaにご登録いただいた日から1か月単位でカウントされます。</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionSix">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSixContent" aria-expanded="true"
                                            aria-controls="QuestionSixContent">
                                            ベーシックプランの利用単語数上限に達するとどうなりますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionSixContent" class="collapse" aria-labelledby="QuestionSix" data-parent="#faq">
                                        <div class="card-body">
                                            <p>単語数の上限に達すると、ベーシックプランではTrinkaをご利用いただけなくなります。その時点でプレミアムプランにアップグレードして、引き続きご利用いただくことが可能です。
                                            </p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionSeven">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionSevenContent" aria-expanded="true"
                                            aria-controls="QuestionSevenContent">
                                            盗用・剽窃チェック、ファイル自動校正、引用チェッカー、出版適正チェックに使えるポイント（Credit）を追加購入することは可能ですか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionSevenContent" class="collapse" aria-labelledby="QuestionSeven" data-parent="#faq">
                                        <div class="card-body">
                                            <p>ベーシックプランでも、プレミアムプランでも、追加ポイントをご購入いただけます。購入したポイントに有効期限はありません。ただしプランに応じて1か月ごとに付与される無料ポイントについては、1か月で期限が切れます。ポイントとポイントパックについて詳しくは <a href="/faqs" class="text-link">こちら</a>をご覧ください。</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionPL">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionPLContent" aria-expanded="true" aria-controls="QuestionPLContent" style="padding-right: 20px">
                                            ベーシックプランで、盗用・剽窃チェック、ファイル自動校正、引用チェッカー、出版適正チェックを利用することはできますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionPLContent" class="collapse" aria-labelledby="QuestionPL" data-parent="#faq">
                                        <div class="card-body">
                                            <p>
                                                ベーシックプランをご利用のお客様にもTrinkaのすべての機能をご利用いただけるだけでなく、必要なときに必要な分だけ追加ポイントをご購入いただき、各機能をご利用いただけるようになりました。
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionEightSection">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightSectionContent" aria-expanded="true"
                                            aria-controls="QuestionEightSectionContent">
                                            プレミアムプランからベーシックプランに変更した場合、追加購入した利用枠はどうなりますか？ 
                                        </a>
                                    </div>
    
                                    <div id="QuestionEightSectionContent" class="collapse" aria-labelledby="QuestionEightSection" data-parent="#faq">
                                        <div class="card-body">
                                            <p>追加でご購入いただいた利用枠はプレミアムプランのご利用を停止した場合でも失効することはありません。</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionEight">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionEightContent" aria-expanded="true"
                                            aria-controls="QuestionEightContent">
                                            プレミアムプランの支払い方法を変更できますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionEightContent" class="collapse" aria-labelledby="QuestionEight" data-parent="#faq">
                                        <div class="card-body">
                                            <p>はい。プレミアムプランを月払いから年払いに変更する場合は、月払いいただいた金額を差し引いた金額のお支払いで変更いただけます。 お支払い方法変更条件の詳細は
                                                <a href="https://www.trinka.ai/termsofservices/" target="_blank">こちら</a>をご覧ください。
                                            </p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionTen">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTenContent" aria-expanded="true"
                                            aria-controls="QuestionTenContent">
                                            Trinkaプレミアムプランの契約をキャンセルしたり、自動更新を停止することはできますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionTenContent" class="collapse" aria-labelledby="QuestionTen" data-parent="#faq">
                                        <div class="card-body">
                                            <p class="mb-2">Trinka（トリンカ）のプレミアムプランの契約はいつでも解約いただけますし、自動更新も停止していただけます。ただしご購入済みのプランについては、期末まで契約は継続し返金はいたしません。解約または自動更新の停止は、以下の手順で行ってください。</p>
                                                <ul>
                                                    <li>Trinkaのアカウントに<a href="https://cloud.trinka.ai/signin?_rg=GB" class="text-link" target="_blank">ログイン</a></li>
                                                    <li>ダッシュボードの右上にある 「Account Settings」をクリック</li>
                                                    <li>「Cancel subscription renewal」のリンクをクリック</li>
                                                </ul>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="Question11">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question11Content" aria-expanded="true"
                                            aria-controls="Question11Content">
                                            データは安全に管理されますか？
                                        </a>
                                    </div>
    
                                    <div id="Question11Content" class="collapse" aria-labelledby="Question11" data-parent="#faq">
                                        <div class="card-body">
                                            <p>はい。高度な暗号化技術により、ご利用いただくユーザーの皆様のデータは安全に管理しています。また、EUのGDPR（General Data Protection Regulation
                                                ：一般データ保護規則）にも準拠しており、ユーザーの個人情報を第三者に提供することはございません。
                                            </p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="Question12">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question12Content" aria-expanded="true"
                                            aria-controls="Question12Content">
                                            <span class="OpenSansFonts">Trinka Enterprise</span>を利用するにはどうすればよいですか？
                                        </a>
                                    </div>
    
                                    <div id="Question12Content" class="collapse" aria-labelledby="Question12" data-parent="#faq">
                                        <div class="card-body">
                                            <p>グループ/チームでのご利用に便利な
                                                <span class="OpenSansFonts">Trinka Enterprise
                                                </span>に関するお問合は、
                                                <a href="" data-toggle="modal" data-target="#EnterPriseContactPopup">お問合せフォーム</a> よりご連絡ください。</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="Question134">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question134Content" aria-expanded="true"
                                            aria-controls="Question134Content">
                                            自社の業態に合わせてTrinkaをカスタマイズできますか？
                                        </a>
                                    </div>
    
                                    <div id="Question134Content" class="collapse" aria-labelledby="Question134" data-parent="#faq">
                                        <div class="card-body">
                                            <p>
                                                <span class="OpenSansFonts">Trinka Enterprise
                                                </span>では、お客様のニーズに応じたカスタマイズ・ソリューション、統合ソリューションを提供しています。
                                                <a href="" data-toggle="modal" data-target="#EnterPriseContactPopup">お問合せフォーム</a>
                                                よりお客様のニーズをお知らせください。</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="Question13">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question13Content" aria-expanded="true"
                                            aria-controls="Question13Content">
                                            さらにサポートが必要です。
                                        </a>
                                    </div>
    
                                    <div id="Question13Content" class="collapse" aria-labelledby="Question13" data-parent="#faq">
                                        <div class="card-body">
                                            <p>
                                                <a href="mailto:support@trinka.ai" class="text-link">support@trinka.ai</a>
                                                までメールにてお知らせください。担当者よりご連絡差し上げます。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="Question14">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#Question14Content" aria-expanded="true"
                                            aria-controls="Question14Content">
                                            自動更新の際、料金はUSドルで請求されるのでしょうか、それとも日本円で請求されるのでしょうか？
                                        </a>
                                    </div>
    
                                    <div id="Question14Content" class="collapse" aria-labelledby="Question14" data-parent="#faq">
                                        <div class="card-body">
                                            <p>自動更新の際、アカウントには最初の支払いが行われた際の通貨で料金が請求されます。お支払い通貨を切り替えるには、一度契約を解約いただき、契約が満了した時点で、プレミアムプランを新たにご購入ください。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="trinka-banner section-pd-sm">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">プレミアムプランなら、全機能を無制限でご利用いただけます</h3>
                    </div>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" class="white-btn" target="_blank">購入する</a>
                    </div>
                </div>
            </div>  
        </div>
    </div>

</div>

<app-enterprise-modal></app-enterprise-modal>
